
// ============ Shopify CDN 映射(嫁接时由脚本注入,2026-05-30)============
const SHOPIFY_CDN_MAP = {"earpad-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-brown_3504114b-a231-4e42-9a5a-2f7bd25ae1f0.png?v=1780076548", "earpad-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-darkgreen_275894ea-8949-4c86-bcb6-1851b54889e3.png?v=1780076548", "earpad-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-navy_491fd150-a5f4-4491-8c89-d0a10fa09f2e.png?v=1780076548", "earpad-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-purple_fc07eeaa-b787-40df-b17f-f7df2265bc5f.png?v=1780076548", "faceplate-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-babyblue_9bb17f3b-4c57-4544-959d-6d8c437b5fb8.png?v=1780076577", "faceplate-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-desertyellow_6fd4dfe4-5afd-4f7e-b2fc-03ee1564218c.png?v=1780076577", "faceplate-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-green_3f50b0fb-a7a8-4b70-a969-12dd7075f11f.png?v=1780076577", "faceplate-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/faceplate-silver_eb4225ca-ac10-4abe-9211-ffce3148ad10.png?v=1780076577", "headband-cube-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-brown_7ead48f1-a924-4586-8beb-ea99c14f0255.png?v=1780076577", "headband-cube-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-brown_7ead48f1-a924-4586-8beb-ea99c14f0255.png?v=1780076577", "headband-cube-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-darkgreen_81e53a7d-d4b8-4db9-a8e2-f230e3745121.png?v=1780076577", "headband-cube-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-darkgreen_81e53a7d-d4b8-4db9-a8e2-f230e3745121.png?v=1780076577", "headband-cube-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-navy_fc3255c8-3b8a-4d86-89fb-3c982a9609aa.png?v=1780076578", "headband-cube-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-navy_fc3255c8-3b8a-4d86-89fb-3c982a9609aa.png?v=1780076578", "headband-cube-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-purple_7294b55e-62b2-41c4-9485-16b786b1bdf5.png?v=1780076577", "headband-cube-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-cube-purple_7294b55e-62b2-41c4-9485-16b786b1bdf5.png?v=1780076577", "headband-flower-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-brown_45a52414-830f-4310-bf35-de7e037ed9fc.png?v=1780076578", "headband-flower-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-brown_45a52414-830f-4310-bf35-de7e037ed9fc.png?v=1780076578", "headband-flower-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-darkgreen_b5fcd885-3dbe-4868-b8d0-13a32fc8f786.png?v=1780076577", "headband-flower-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-darkgreen_b5fcd885-3dbe-4868-b8d0-13a32fc8f786.png?v=1780076577", "headband-flower-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-navy_b4f547bc-17c5-4711-91f1-ae717d801cc5.png?v=1780076605", "headband-flower-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-navy_b4f547bc-17c5-4711-91f1-ae717d801cc5.png?v=1780076605", "headband-flower-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-purple_b99a4bd9-ece5-4087-8e39-becc0b770e1a.png?v=1780076606", "headband-flower-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-flower-purple_b99a4bd9-ece5-4087-8e39-becc0b770e1a.png?v=1780076606", "headband-fluid-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-brown_1402e26a-7008-4f1b-b852-05867e28b2af.png?v=1780076605", "headband-fluid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-brown_1402e26a-7008-4f1b-b852-05867e28b2af.png?v=1780076605", "headband-fluid-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-darkgreen_6aa4346c-e4f6-476c-a7fb-4fbd885caf2f.png?v=1780076605", "headband-fluid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-darkgreen_6aa4346c-e4f6-476c-a7fb-4fbd885caf2f.png?v=1780076605", "headband-fluid-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-navy_63f32837-5b7c-4d43-97dc-5d93e6826ac3.png?v=1780076605", "headband-fluid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-navy_63f32837-5b7c-4d43-97dc-5d93e6826ac3.png?v=1780076605", "headband-fluid-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-purple_88cce80b-124a-44f2-8e47-ed3d9a6aba24.png?v=1780076606", "headband-fluid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-fluid-purple_88cce80b-124a-44f2-8e47-ed3d9a6aba24.png?v=1780076606", "headband-line-brown-green.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-green_be62608a-fe1f-4877-9132-52b9f3d02450.png?v=1780076605", "headband-line-brown-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-green_be62608a-fe1f-4877-9132-52b9f3d02450.png?v=1780076605", "headband-line-brown-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-yellow_d8d720c3-19dd-40d3-9da7-9c83cf11e0b3.png?v=1780076605", "headband-line-brown-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-brown-yellow_d8d720c3-19dd-40d3-9da7-9c83cf11e0b3.png?v=1780076605", "headband-line-darkgreen-red.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-red_5729762f-c6e0-4320-aa82-295bc177e1ec.png?v=1780076605", "headband-line-darkgreen-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-red_5729762f-c6e0-4320-aa82-295bc177e1ec.png?v=1780076605", "headband-line-darkgreen-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-yellow_32d3a87c-11da-45cb-b182-984bb06267dc.png?v=1780076605", "headband-line-darkgreen-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-darkgreen-yellow_32d3a87c-11da-45cb-b182-984bb06267dc.png?v=1780076605", "headband-line-navy-red.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-red_eca68a61-8512-43ce-be8a-f9c426e359de.png?v=1780076631", "headband-line-navy-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-red_eca68a61-8512-43ce-be8a-f9c426e359de.png?v=1780076631", "headband-line-navy-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-yellow_9a12e37e-ace1-4404-9cbe-8d708351a155.png?v=1780076630", "headband-line-navy-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-navy-yellow_9a12e37e-ace1-4404-9cbe-8d708351a155.png?v=1780076630", "headband-line-purple-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-navy_39eacdbf-45db-4cb3-8f18-e0e4d9395750.png?v=1780076630", "headband-line-purple-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-navy_39eacdbf-45db-4cb3-8f18-e0e4d9395750.png?v=1780076630", "headband-line-purple-yellow.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-yellow_de7bdf91-0035-41c5-aee4-15b7b8a9e5bd.png?v=1780076631", "headband-line-purple-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-line-purple-yellow_de7bdf91-0035-41c5-aee4-15b7b8a9e5bd.png?v=1780076631", "headband-liuli-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-brown_20b0c7a0-b4f7-41c4-a388-2a753a249b6c.png?v=1780076630", "headband-liuli-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-brown_20b0c7a0-b4f7-41c4-a388-2a753a249b6c.png?v=1780076630", "headband-liuli-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-darkgreen_8525bd5b-56ca-46d2-b872-88490cd33311.png?v=1780076631", "headband-liuli-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-darkgreen_8525bd5b-56ca-46d2-b872-88490cd33311.png?v=1780076631", "headband-liuli-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-navy_fd38340b-2af9-4be1-addb-c66fb11dad08.png?v=1780076630", "headband-liuli-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-navy_fd38340b-2af9-4be1-addb-c66fb11dad08.png?v=1780076630", "headband-liuli-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-purple_11588861-5c41-43af-879f-69071e0fc11d.png?v=1780076631", "headband-liuli-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-liuli-purple_11588861-5c41-43af-879f-69071e0fc11d.png?v=1780076631", "headband-quantum-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-brown_15da65f3-3fbc-41a0-8498-1342fb146ac1.png?v=1780076630", "headband-quantum-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-brown_15da65f3-3fbc-41a0-8498-1342fb146ac1.png?v=1780076630", "headband-quantum-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-darkgreen_dfab3fed-afed-42fa-b596-5060568124ac.png?v=1780076630", "headband-quantum-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-darkgreen_dfab3fed-afed-42fa-b596-5060568124ac.png?v=1780076630", "headband-quantum-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-navy_9d3932dd-f80e-45f8-8986-41c7af028325.png?v=1780076656", "headband-quantum-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-navy_9d3932dd-f80e-45f8-8986-41c7af028325.png?v=1780076656", "headband-quantum-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-purple_f24c8673-ad51-4137-ad9d-a8a74bc1c475.png?v=1780076656", "headband-quantum-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-quantum-purple_f24c8673-ad51-4137-ad9d-a8a74bc1c475.png?v=1780076656", "headband-solid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-brown_ba26d6e9-6e91-4bf4-a926-76aed92218e7.png?v=1780076656", "headband-solid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-darkgreen_01a6f83d-211e-4cd6-9bc0-78e6fbe33cfe.png?v=1780076656", "headband-solid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-navy_21b644c9-326b-4d71-9125-ae42f671a595.png?v=1780076656", "headband-solid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-solid-purple_d0129bd7-18ee-400f-a832-e85dcafd0c2c.png?v=1780076656", "headband-time-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-brown_14d1eae2-2cf2-496e-8249-6ece7cb8d777.png?v=1780076656", "headband-time-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-brown_14d1eae2-2cf2-496e-8249-6ece7cb8d777.png?v=1780076656", "headband-time-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-darkgreen_decaf9a4-461a-4735-a096-c23c1c0773e2.png?v=1780076656", "headband-time-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-darkgreen_decaf9a4-461a-4735-a096-c23c1c0773e2.png?v=1780076656", "headband-time-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-navy_8cb06dd1-d701-44ae-a28b-ab87aba570cb.png?v=1780076656", "headband-time-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-navy_8cb06dd1-d701-44ae-a28b-ab87aba570cb.png?v=1780076656", "headband-time-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-purple_4f81a35a-2a8a-472f-a91b-593675f892dd.png?v=1780076656", "headband-time-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-time-purple_4f81a35a-2a8a-472f-a91b-593675f892dd.png?v=1780076656", "headband-totem-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-brown_19ea12f6-c7ca-48fc-b0e5-11059e1a49c8.png?v=1780076684", "headband-totem-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-brown_19ea12f6-c7ca-48fc-b0e5-11059e1a49c8.png?v=1780076684", "headband-totem-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-darkgreen_24f5e721-7718-4043-942d-b297b7b7d18e.png?v=1780076684", "headband-totem-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-darkgreen_24f5e721-7718-4043-942d-b297b7b7d18e.png?v=1780076684", "headband-totem-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-navy_21e4d009-531c-4523-b479-ddc0f28b3861.png?v=1780076684", "headband-totem-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-navy_21e4d009-531c-4523-b479-ddc0f28b3861.png?v=1780076684", "headband-totem-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-purple_fe63c9d6-69be-4e82-8b8f-bd999bcb4312.png?v=1780076684", "headband-totem-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-totem-purple_fe63c9d6-69be-4e82-8b8f-bd999bcb4312.png?v=1780076684", "headband-youth-brown.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-brown_0a580d7b-619e-4966-8754-04709d06faa7.png?v=1780076685", "headband-youth-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-brown_0a580d7b-619e-4966-8754-04709d06faa7.png?v=1780076685", "headband-youth-darkgreen.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-darkgreen_2d960fb0-5a0b-4fde-9aca-026be8f7f1fa.png?v=1780076684", "headband-youth-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-darkgreen_2d960fb0-5a0b-4fde-9aca-026be8f7f1fa.png?v=1780076684", "headband-youth-navy.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-navy_a2561d20-ee41-4a73-9e34-b7a14ab546cf.png?v=1780076684", "headband-youth-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-navy_a2561d20-ee41-4a73-9e34-b7a14ab546cf.png?v=1780076684", "headband-youth-purple.jpg": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-purple_a864c0d9-5267-4ef5-b4fb-66676eff49ef.png?v=1780076684", "headband-youth-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/headband-youth-purple_a864c0d9-5267-4ef5-b4fb-66676eff49ef.png?v=1780076684", "earpad-halfear-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-brown.png?v=1780076548", "earpad-halfear-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-darkgreen.png?v=1780076548", "earpad-halfear-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-navy.png?v=1780076548", "earpad-halfear-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/earpad-halfear-purple.png?v=1780076548", "host-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-babyblue.png?v=1780076684", "host-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-desertyellow.png?v=1780076684", "host-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-green.png?v=1780076707", "host-halfear-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-babyblue.png?v=1780076707", "host-halfear-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-desertyellow.png?v=1780076707", "host-halfear-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-green.png?v=1780076708", "host-halfear-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-halfear-silver.png?v=1780076707", "host-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/host-silver.png?v=1780076707", "shadow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/shadow.png?v=1780076708", "适配图/earpad-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-brown.png?v=1780076901", "适配图/earpad-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-darkgreen.png?v=1780077132", "适配图/earpad-halfear-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-darkgreen.png?v=1780076901", "适配图/earpad-halfear-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-navy.png?v=1780076901", "适配图/earpad-halfear-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-halfear-purple.png?v=1780076901", "适配图/earpad-halfear-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-navy.png?v=1780076901", "适配图/earpad-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-earpad-purple.png?v=1780076901", "适配图/earpad-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-babyblue.png?v=1780076901", "适配图/faceplate-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-desertyellow.png?v=1780076901", "适配图/faceplate-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-green.png?v=1780076931", "适配图/faceplate-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-faceplate-silver.png?v=1780076931", "适配图/headband-cube-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-brown.png?v=1780076931", "适配图/headband-cube-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-darkgreen.png?v=1780076931", "适配图/headband-cube-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-navy.png?v=1780076931", "适配图/headband-cube-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-cube-purple.png?v=1780076931", "适配图/headband-flower-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-brown.png?v=1780076931", "适配图/headband-flower-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-darkgreen.png?v=1780076931", "适配图/headband-flower-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-navy.png?v=1780076931", "适配图/headband-flower-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-flower-purple.png?v=1780076931", "适配图/headband-fluid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-brown.png?v=1780076970", "适配图/headband-fluid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-darkgreen.png?v=1780076970", "适配图/headband-fluid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-navy.png?v=1780076970", "适配图/headband-fluid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-fluid-purple.png?v=1780076970", "适配图/headband-line-brown-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-brown-green.png?v=1780076970", "适配图/headband-line-brown-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-brown-yellow.png?v=1780076970", "适配图/headband-line-darkgreen-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-darkgreen-red.png?v=1780076970", "适配图/headband-line-darkgreen-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-darkgreen-yellow.png?v=1780076970", "适配图/headband-line-navy-red.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-navy-red.png?v=1780076970", "适配图/headband-line-navy-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-navy-yellow.png?v=1780076970", "适配图/headband-line-purple-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-purple-navy.png?v=1780077004", "适配图/headband-line-purple-yellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-line-purple-yellow.png?v=1780077004", "适配图/headband-liuli-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-brown.png?v=1780077003", "适配图/headband-liuli-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-darkgreen.png?v=1780077004", "适配图/headband-liuli-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-navy.png?v=1780077004", "适配图/headband-liuli-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-liuli-purple.png?v=1780077003", "适配图/headband-quantum-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-brown.png?v=1780077003", "适配图/headband-quantum-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-darkgreen.png?v=1780077004", "适配图/headband-quantum-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-navy.png?v=1780077004", "适配图/headband-quantum-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-quantum-purple.png?v=1780077004", "适配图/headband-solid-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-brown.png?v=1780077035", "适配图/headband-solid-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-darkgreen.png?v=1780077034", "适配图/headband-solid-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-navy.png?v=1780077035", "适配图/headband-solid-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-solid-purple.png?v=1780077035", "适配图/headband-time-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-brown.png?v=1780077035", "适配图/headband-time-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-darkgreen.png?v=1780077035", "适配图/headband-time-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-navy.png?v=1780077034", "适配图/headband-time-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-time-purple.png?v=1780077035", "适配图/headband-totem-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-brown.png?v=1780077034", "适配图/headband-totem-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-darkgreen.png?v=1780077034", "适配图/headband-totem-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-navy.png?v=1780077064", "适配图/headband-totem-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-totem-purple.png?v=1780077064", "适配图/headband-youth-brown.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-brown.png?v=1780077064", "适配图/headband-youth-darkgreen.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-darkgreen.png?v=1780077064", "适配图/headband-youth-navy.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-navy.png?v=1780077064", "适配图/headband-youth-purple.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-headband-youth-purple.png?v=1780077064", "适配图/host-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-babyblue.png?v=1780077064", "适配图/host-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-desertyellow.png?v=1780077064", "适配图/host-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-green.png?v=1780077064", "适配图/host-halfear-babyblue.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-babyblue.png?v=1780077064", "适配图/host-halfear-desertyellow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-desertyellow.png?v=1780077081", "适配图/host-halfear-green.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-green.png?v=1780077081", "适配图/host-halfear-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-halfear-silver.png?v=1780077081", "适配图/host-silver.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-host-silver.png?v=1780077081", "适配图/shadow.png": "https://cdn.shopify.com/s/files/1/0685/2100/1133/files/adapt-shadow.png?v=1780077081"};
function cdnUrl(rel) {
  // rel 形如 '素材/xxx.png' 或 '素材/适配图/xxx.png'
  // 嫁接-9 · 优先查 window.RAINBOW_ASSETS(主题 assets/,Liquid 渲染);
  // 不命中再 fallback 到旧 SHOPIFY_CDN_MAP(Files CDN,部分错位但保留兼容)
  if (typeof window !== 'undefined' && window.RAINBOW_ASSETS && window.RAINBOW_ASSETS[rel]) {
    return window.RAINBOW_ASSETS[rel];
  }
  const key = rel.replace(/^素材\//, '');
  return SHOPIFY_CDN_MAP[key] || rel;
}
// ============ Shopify 产品映射(原 fetch ./data/rainbow-mapping.json,现 inline)============
const SHOPIFY_MAPPING_INLINE = {"host": {"silver": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387453101", "variant_title": "Starry Silver", "sku": null, "price": "0.00", "inventory": 0}, "desertyellow": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387944621", "variant_title": "Desert Yellow", "sku": null, "price": "0.00", "inventory": 0}, "babyblue": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040387977389", "variant_title": "Serene Blue", "sku": null, "price": "0.00", "inventory": 0}, "green": {"product_id": "gid://shopify/Product/8590734229677", "product_handle": "monixibi-rainbow-headphones", "product_title": "Rainbow Headphones", "variant_id": "gid://shopify/ProductVariant/46040388010157", "variant_title": "Retro Green", "sku": null, "price": "0.00", "inventory": 0}}, "faceplate": {"babyblue": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074764973", "variant_title": "Serene Blue", "sku": "", "price": "30.00", "inventory": 20}, "green": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074830509", "variant_title": "Retro Green", "sku": "", "price": "30.00", "inventory": 20}, "silver": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074732205", "variant_title": "Starry Silver", "sku": "", "price": "30.00", "inventory": 20}, "desertyellow": {"product_id": "gid://shopify/Product/7993460687021", "product_handle": "monixibi-rainbow-ear-cup-cover-faceplates", "product_title": "Rainbow Faceplates", "variant_id": "gid://shopify/ProductVariant/44043074797741", "variant_title": "Desert Yellow", "sku": "", "price": "30.00", "inventory": 20}}, "earpad_full": {"darkgreen": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066867885", "variant_title": "Dark Green", "sku": "", "price": "39.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066835117", "variant_title": "Deep Purple", "sku": "", "price": "39.00", "inventory": 20}, "navy": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066769581", "variant_title": "Deep Blue", "sku": "", "price": "39.00", "inventory": 20}, "brown": {"product_id": "gid://shopify/Product/7993455214765", "product_handle": "monixibi-rainbow-ear-cushion-cover-leather-case", "product_title": "Rainbow Over-Ear Cushions", "variant_id": "gid://shopify/ProductVariant/44043066802349", "variant_title": "Coffee Brown", "sku": "", "price": "39.00", "inventory": 20}}, "earpad_half": {"brown": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085217965", "variant_title": "Coffee Brown", "sku": "44043085217965", "price": "19.00", "inventory": 20}, "navy": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085185197", "variant_title": "Deep Blue", "sku": "44043085185197", "price": "19.00", "inventory": 20}, "darkgreen": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085250733", "variant_title": "Dark Green", "sku": "44043085250733", "price": "19.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993461276845", "product_handle": "monixibi-rainbow-half-ear-earpads", "product_title": "Rainbow Half-Ear Earpads", "variant_id": "gid://shopify/ProductVariant/44043085283501", "variant_title": "Deep Purple", "sku": "44043085283501", "price": "19.00", "inventory": 20}}, "headband": {"line-navy-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795713197", "variant_title": "Blue and Yellow Line", "sku": "44765795713197", "price": "99.00", "inventory": 20}, "line-navy-red": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795745965", "variant_title": "Blue and Red Line", "sku": "44765795745965", "price": "99.00", "inventory": 20}, "line-brown-green": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795778733", "variant_title": "Brown and Green Line", "sku": "44765795778733", "price": "99.00", "inventory": 20}, "line-brown-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44765795811501", "variant_title": "Brown and Yellow Line", "sku": "44765795811501", "price": "99.00", "inventory": 20}, "line-darkgreen-red": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588010669", "variant_title": "Red and Green Line", "sku": "44766588010669", "price": "99.00", "inventory": 20}, "line-darkgreen-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588043437", "variant_title": "Yellow and Green Line", "sku": "44766588043437", "price": "99.00", "inventory": 20}, "line-purple-yellow": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588076205", "variant_title": "Purple and Yellow Line", "sku": "44766588076205", "price": "99.00", "inventory": 20}, "line-purple-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588108973", "variant_title": "Purple and Blue Line", "sku": "44766588108973", "price": "99.00", "inventory": 20}, "flower-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588141741", "variant_title": "Floral Blue", "sku": "44766588141741", "price": "99.00", "inventory": 20}, "flower-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588174509", "variant_title": "Floral Brown", "sku": "44766588174509", "price": "99.00", "inventory": 20}, "flower-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588207277", "variant_title": "Floral Green", "sku": "44766588207277", "price": "99.00", "inventory": 20}, "flower-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588240045", "variant_title": "Floral Purple", "sku": "44766588240045", "price": "99.00", "inventory": 20}, "totem-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588272813", "variant_title": "Blue totem", "sku": "44766588272813", "price": "99.00", "inventory": 20}, "totem-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588305581", "variant_title": "Brown totem", "sku": "44766588305581", "price": "99.00", "inventory": 20}, "totem-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588338349", "variant_title": "Green totem", "sku": "44766588338349", "price": "99.00", "inventory": 20}, "totem-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766588371117", "variant_title": "Purple totem", "sku": "44766588371117", "price": "99.00", "inventory": 20}, "fluid-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604853421", "variant_title": "Flowing Blue", "sku": "44766604853421", "price": "99.00", "inventory": 20}, "fluid-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604886189", "variant_title": "Flowing Brown", "sku": "44766604886189", "price": "99.00", "inventory": 20}, "fluid-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604918957", "variant_title": "Flowing Green", "sku": "44766604918957", "price": "99.00", "inventory": 20}, "fluid-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604951725", "variant_title": "Flowing Purple", "sku": "44766604951725", "price": "99.00", "inventory": 20}, "liuli-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766604984493", "variant_title": "Liuli Blue", "sku": "44766604984493", "price": "99.00", "inventory": 20}, "liuli-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605017261", "variant_title": "Liuli Brown", "sku": "44766605017261", "price": "99.00", "inventory": 20}, "liuli-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605050029", "variant_title": "Liuli Green", "sku": "44766605050029", "price": "99.00", "inventory": 20}, "liuli-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605082797", "variant_title": "Liuli Purple", "sku": "44766605082797", "price": "99.00", "inventory": 20}, "youth-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605115565", "variant_title": "Youth Blue", "sku": "44766605115565", "price": "99.00", "inventory": 20}, "youth-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605148333", "variant_title": "Youth Brown", "sku": "44766605148333", "price": "99.00", "inventory": 20}, "youth-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605181101", "variant_title": "Youth Green", "sku": "44766605181101", "price": "99.00", "inventory": 20}, "youth-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605213869", "variant_title": "Youth Purple", "sku": "44766605213869", "price": "99.00", "inventory": 20}, "cube-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605246637", "variant_title": "Magic Cube Blue", "sku": "44766605246637", "price": "99.00", "inventory": 20}, "cube-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605279405", "variant_title": "Magic Cube Brown", "sku": "44766605279405", "price": "99.00", "inventory": 20}, "cube-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605312173", "variant_title": "Magic Cube Green", "sku": "44766605312173", "price": "99.00", "inventory": 20}, "cube-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605344941", "variant_title": "Magic Cube Purple", "sku": "44766605344941", "price": "99.00", "inventory": 20}, "quantum-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605377709", "variant_title": "Quantum Blue", "sku": "44766605377709", "price": "99.00", "inventory": 20}, "quantum-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605410477", "variant_title": "Quantum Brown", "sku": "44766605410477", "price": "99.00", "inventory": 20}, "quantum-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605443245", "variant_title": "Quantum Green", "sku": "44766605443245", "price": "99.00", "inventory": 20}, "quantum-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605476013", "variant_title": "Quantum Purple", "sku": "44766605476013", "price": "99.00", "inventory": 20}, "time-navy": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605508781", "variant_title": "Year of Flow Blue", "sku": "44766605508781", "price": "99.00", "inventory": 20}, "time-brown": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605541549", "variant_title": "Year of Flow Brown", "sku": "44766605541549", "price": "99.00", "inventory": 20}, "time-darkgreen": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605574317", "variant_title": "Year of Flow Green", "sku": "44766605574317", "price": "99.00", "inventory": 20}, "time-purple": {"product_id": "gid://shopify/Product/8271189213357", "product_handle": "monixibi-rainbow-headband", "product_title": "Rainbow Headband", "variant_id": "gid://shopify/ProductVariant/44766605607085", "variant_title": "Year of Flow Purple", "sku": "44766605607085", "price": "99.00", "inventory": 20}}, "moni_strap": {"navy": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090559149", "variant_title": "Deep Blue", "sku": "", "price": "79.00", "inventory": 20}, "brown": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090591917", "variant_title": "Coffee Brown", "sku": "", "price": "79.00", "inventory": 20}, "darkgreen": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090624685", "variant_title": "Dark Green", "sku": "", "price": "79.00", "inventory": 20}, "purple": {"product_id": "gid://shopify/Product/7993483526317", "product_handle": "monixibi-rainbow-moni-strap", "product_title": "Rainbow Moni-Strap", "variant_id": "gid://shopify/ProductVariant/44043090657453", "variant_title": "Deep Purple", "sku": "", "price": "79.00", "inventory": 20}}, "_meta": {"generated_at": "2026-05-22T21:35:29.259459", "total_mapped": 60, "unmapped_variants_count": 0, "unmapped_samples": []}};

/* ============================================================
   §7 DATA · 色名 / 色值
   ============================================================ */
// 主机 / 面盖 共池(4 色,同色系)
const HOSTS = [
  { slug: 'silver',       cn: '星空银', hex: '#D6D7DC' },
  { slug: 'desertyellow', cn: '大漠黄', hex: '#E8C97A' },
  { slug: 'babyblue',     cn: '静谧蓝', hex: '#BCD0E8' },
  { slug: 'green',        cn: '复古绿', hex: '#A8C5A1' },
];
// 面盖 4 色(色池跟主机一致,但带 image 字段用真实按钮图)
const FACEPLATES = [
  { slug: 'silver',       cn: '星空银', hex: '#D6D7DC', image: cdnUrl('素材/faceplate-silver.png') },
  { slug: 'desertyellow', cn: '大漠黄', hex: '#E8C97A', image: cdnUrl('素材/faceplate-desertyellow.png') },
  { slug: 'babyblue',     cn: '静谧蓝', hex: '#BCD0E8', image: cdnUrl('素材/faceplate-babyblue.png') },
  { slug: 'green',        cn: '复古绿', hex: '#A8C5A1', image: cdnUrl('素材/faceplate-green.png') },
];

// 全包耳皮套 4 色(image 是真实皮套按钮图)
const EARPADS = [
  { slug: 'navy',      cn: '深蓝色', hex: '#1F2A55', image: cdnUrl('素材/earpad-navy.png') },
  { slug: 'darkgreen', cn: '墨绿色', hex: '#243E2C', image: cdnUrl('素材/earpad-darkgreen.png') },
  { slug: 'purple',    cn: '深紫色', hex: '#3A2557', image: cdnUrl('素材/earpad-purple.png') },
  { slug: 'brown',     cn: '深棕色', hex: '#5B3F2E', image: cdnUrl('素材/earpad-brown.png') },
];

// 阶段 A · 魔尼带(Moni-Strap)4 色,跟全包皮套色一一对应,套装内仅 1 件(全局共用,不分副)
const MONI_STRAPS = [
  { slug: 'navy',      cn: '深蓝色', hex: '#1F2A55', image: cdnUrl('素材/moni-strap-navy.png') },
  { slug: 'darkgreen', cn: '墨绿色', hex: '#243E2C', image: cdnUrl('素材/moni-strap-darkgreen.png') },
  { slug: 'purple',    cn: '深紫色', hex: '#3A2557', image: cdnUrl('素材/moni-strap-purple.png') },
  { slug: 'brown',     cn: '深棕色', hex: '#5B3F2E', image: cdnUrl('素材/moni-strap-brown.png') },
];
// 魔尼带英文色名映射(用于加购 properties,跟 Shopify 后台一致)
const MONI_STRAP_EN = {
  navy:      'Deep Blue',
  darkgreen: 'Dark Green',
  purple:    'Deep Purple',
  brown:     'Coffee Brown',
};

// 阶段 C · 颜色英文映射(Shopify 后台 line item properties 规范,2026-06-01)
const HOST_EN = {
  silver:       'Starry Silver',
  desertyellow: 'Desert Yellow',
  babyblue:     'Serene Blue',
  green:        'Retro Green',
};
// 面盖跟主机色一一对应,英文名相同
const FACEPLATE_EN = HOST_EN;
// 全包皮套 4 色英文名
const EARPAD_EN = {
  navy:      'Deep Blue',
  darkgreen: 'Dark Green',
  purple:    'Deep Purple',
  brown:     'Coffee Brown',
};

// 阶段 C · Shopify 后台 DIY product 3 个 variant_id(numeric,不是 gid),2026-06-01 用户确认
const DIY_VARIANT_IDS = {
  1: 46073729384621,  // Rainbow DIY - First Pair  $299 · 5 件
  2: 46073729712301,  // Rainbow DIY - Second Pair $349 · 8 件 · 主推
  3: 46073731547309,  // Rainbow DIY - Third Pair  $389 · 11 件
};
const DIY_PRICES = { 1: 299, 2: 349, 3: 389 };

// SoT § 7 半包耳锁死表:主机色 → 标配皮套 + 头带色
const LOCKED_PAIRS = {
  silver:       'navy',       // 星空银 → 深蓝
  desertyellow: 'darkgreen',  // 大漠黄 → 墨绿
  babyblue:     'purple',     // 静谧蓝 → 深紫
  green:        'brown',      // 复古绿 → 深棕
};

// —— 头带 44 款生成(SoT § 3) ——
// 4 系列底色 + 8 设计系列 + 8 线条款 + 4 纯色
const BASE_COLORS = ['brown', 'navy', 'purple', 'darkgreen'];
const BASE_HEX = { brown: '#5B3F2E', navy: '#1F2A55', purple: '#3A2557', darkgreen: '#243E2C' };
const BASE_CN  = { brown: '棕', navy: '蓝', purple: '紫', darkgreen: '绿' };
const SOLID_CN = { brown: '深棕色', navy: '深蓝色', purple: '深紫色', darkgreen: '墨绿色' };
const SERIES = [
  { slug: 'totem',   cn: '图腾' },
  { slug: 'liuli',   cn: '琉璃' },
  { slug: 'quantum', cn: '量子' },
  { slug: 'fluid',   cn: '流体' },
  { slug: 'cube',    cn: '魔方' },
  { slug: 'flower',  cn: '花语' },
  { slug: 'youth',   cn: '青春' },
  { slug: 'time',    cn: '流年' },
];
const LINE_PAIRS = [
  ['brown', 'yellow'], ['brown', 'green'],
  ['navy',  'red'],    ['navy',  'yellow'],
  ['purple','navy'],   ['purple','yellow'],
  ['darkgreen','red'], ['darkgreen','yellow'],
];
const ACCENT_CN = { yellow: '黄', red: '红', green: '绿', navy: '蓝' };
const ACCENT_HEX = { yellow: '#E8C97A', red: '#C7423A', green: '#A8C5A1', navy: '#1F2A55' };

function buildHeadbands() {
  const list = [];
  // 4 纯色(去底抠图)· baseColor 字段显式标底色,免后续 split('-')[1] 反推
  BASE_COLORS.forEach(c => list.push({
    slug: `solid-${c}`, type: 'solid', hex: BASE_HEX[c],
    cn: SOLID_CN[c], accentHex: '#ffffff66',
    image: cdnUrl(`素材/headband-solid-${c}.png`),
    baseColor: c,
  }));
  // 8 线条(有图)
  LINE_PAIRS.forEach(([a, b]) => list.push({
    slug: `line-${a}-${b}`, type: 'line', hex: BASE_HEX[a],
    cn: BASE_CN[a] + ACCENT_CN[b] + '线',
    accentHex: ACCENT_HEX[b],
    image: cdnUrl(`素材/headband-line-${a}-${b}.png`),
    baseColor: a,
  }));
  // 32 设计款(有图)
  SERIES.forEach(s => BASE_COLORS.forEach(c => list.push({
    slug: `${s.slug}-${c}`, type: 'design', hex: BASE_HEX[c],
    cn: s.slug === 'totem' ? (BASE_CN[c] + s.cn) : (s.cn + BASE_CN[c]),
    accentHex: 'rgba(255,255,255,.6)',
    image: cdnUrl(`素材/headband-${s.slug}-${c}.png`),
    baseColor: c,
  })));
  return list;
}
const ALL_HEADBANDS = buildHeadbands();

// 适配图存在性表(主图预览卡 4 层叠加用,1:1 画布 PNG)
// 全包耳形态用 ${type}-${slug}.png(host/faceplate/earpad/headband)
// 半包耳形态用 host-halfear-${slug}.png / earpad-halfear-${slug}.png(2026-05-20 补齐 8 张)
// 直接从数据源派生,避免手写列表跟数据池失同步
const ADAPT_IMAGES = {
  // 头带:ALL_HEADBANDS 全部有 image 字段(44 款都有),用 slug 全集
  headband:  new Set(ALL_HEADBANDS.map(h => h.slug)),
  // 主机 / 面盖 / 全包皮套 跟 4 色池一一对齐
  host:      new Set(HOSTS.map(h => h.slug)),
  faceplate: new Set(FACEPLATES.map(f => f.slug)),
  earpad:    new Set(EARPADS.map(e => e.slug)),
  // 半包耳专属命名空间(目前 4 色全有图,跟 HOSTS / EARPADS 一致;若以后某色缺图,改这里手写)
  host_halfear:   new Set(HOSTS.map(h => h.slug)),
  earpad_halfear: new Set(EARPADS.map(e => e.slug)),
};

// 返回 url('...') 或 'none'(走 fallback 颜色块)
// 缺图静默 fallback 容易把素材缺口憋成视觉怪图,开发期 warn 一下方便发现 typo / 漏图
function adaptImg(type, slug, form) {
  // 半包耳形态走专属命名空间(host 和 earpad 都有视觉差异)
  if (form === 'halfear' && (type === 'host' || type === 'earpad')) {
    const key = `${type}_halfear`;
    if (!ADAPT_IMAGES[key] || !ADAPT_IMAGES[key].has(slug)) {
      console.warn(`[adaptImg] 缺图: ${key} / ${slug}, 走 fallback`);
      return 'none';
    }
    return `url('${cdnUrl('素材/适配图/' + type + '-halfear-' + slug + '.png')}')`;
  }
  if (!ADAPT_IMAGES[type] || !ADAPT_IMAGES[type].has(slug)) {
    console.warn(`[adaptImg] 缺图: ${type} / ${slug}, 走 fallback`);
    return 'none';
  }
  return `url('${cdnUrl('素材/适配图/' + type + '-' + slug + '.png')}')`;
}

// 给定主机色 → 头带池(标配那条保留并标 isBonus,渲染时显示"标"角标 + 禁选)
function getHeadbandPool(host) {
  const lockedSolid = `solid-${LOCKED_PAIRS[host]}`;
  return ALL_HEADBANDS.map(h => h.slug === lockedSolid ? { ...h, isBonus: true } : h);
}
// slug → 头带对象
const HEADBAND_MAP = Object.fromEntries(ALL_HEADBANDS.map(h => [h.slug, h]));

// 价格(占位)
const PRICE = {
  base:      269,   // 主机 + 标配头带 + 半包耳皮套(品牌定价,2026-05-25 锁死)
  faceplate: 49,    // 1 套面盖(必含 2 色)
  earpad:    59,    // 1 套全包耳皮套(必含 2 色)
  headband:  29,    // 1 套头带(必含 2 款)
  extraHost: 89,    // 多加 1 主机
  moniStrap: 19,    // 魔尼带
};
// v16.0 MVP · 副数定价表(plan 销售模型,2026-05-29):用副数决定价格,覆盖 totalPrice() 旧模型
// 阶段 C · 价格改 DIY product 真实挂牌价(替代 MVP 测试 199/280/360),2026-06-01
const KIT_PRICE = DIY_PRICES;
function totalPriceMvp() { return KIT_PRICE[state.kitCount] || 349; }

/* ============================================================
   §8 STATE (v13 · 引导式 DIY)
   ============================================================ */
// 默认进站态:Build 1 空待用户挑(activeBuild=0),Build 2 灰禁锁(等 Build 1 装好)
const state = {
  base: {
    host: 'desertyellow',
  },
  builds: [
    // Build 1 默认示范:大漠黄主机 + 红绿线头带 + 星空银面盖 + 墨绿全包皮套
    { faceplate: 'silver', headband: 'line-darkgreen-red', earpad: 'darkgreen' },
    // Build 2 空(等用户挑)— 因 Build 1 完成,Tab 自动解锁
    { faceplate: null, headband: null, earpad: null },
  ],
  extras: { extraHosts: 0 },
  // 阶段 A · 魔尼带:全套装 1 件,锁色联动 Build 1 的全包皮套色(linked=true);可解锁自由选(linked=false)
  moniStrap: { slug: 'darkgreen', linked: true },
  // v16.0 MVP · 副数(1/2/3,默认 2 副)— 用于 Shopify 嫁接 payload 区分,显示价格 $199/$280/$360
  kitCount: 2,
  currentVariantIdx: 0,
  // UI 状态
  activeBuild: 0,
  detailsOpen: [false, false],
  headbandTab: 'design',
  helpOpen: { host: false, build1: false, build2: false },
  // 头带 ↔ 皮套色双向绑定(默认开):选其中一个,另一个自动同底色
  headbandLinked: true,
  headbandLinkHelpOpen: false,
  // 头带横滑位置缓存(render 重渲染后恢复,避免回弹到第一条)
  headbandScrollLeft: 0,
  // 同步皮套→头带时,要求 render 后把 picker 滚到这个 slug(用完清空)
  headbandScrollTo: null,
  // 滚动对齐方式:'center'(选中 chip 居中) / 'start'(把目标 chip 推到最左,后面 3 条同分类一起露出)
  headbandScrollMode: 'center',
  previewMode: 'build',
  // hero ⊕ 教学卡展开态(默认收起)
  heroGuideOpen: false,
};

// 进站态:Build 1 已选头带 → 自动把 picker 滚到该位置 + 同步 tab(用户期望"装第 1 副"打开就看到当前选中头带)
(() => {
  const b1Hb = state.builds[0].headband;
  if (b1Hb && HEADBAND_MAP[b1Hb]) {
    state.headbandTab = HEADBAND_MAP[b1Hb].type;
    state.headbandScrollTo = b1Hb;
  }
})();

// ── 工具函数 ──
const buildComplete = (b) => !!(b.faceplate && b.headband && b.earpad);
const allComplete   = () => buildComplete(state.builds[0]) && buildComplete(state.builds[1]);
// 阶段 A · 魔尼带实际生效色 slug:linked 时跟 Build 1 皮套色;否则用 state.moniStrap.slug 用户独立选
function getMoniStrapSlug() {
  if (state.moniStrap.linked) {
    return state.builds[0].earpad || state.moniStrap.slug;
  }
  return state.moniStrap.slug;
}
// 某个槽位在两副里被用过的 slug(防重复 chip 灰禁用)
const usedSlugs     = (field) => [state.builds[0][field], state.builds[1][field]].filter(Boolean);

// ── 头带 ↔ 皮套 双向同色绑定 ──
// 头带数据已带 baseColor 字段(buildHeadbands 构造时显式标),直接读 map,免靠 slug 拆分约定
function getHeadbandBaseColor(slug) {
  if (!slug) return null;
  return HEADBAND_MAP[slug]?.baseColor || null;
}
const EARPAD_COLORS = ['navy', 'darkgreen', 'purple', 'brown'];
// linked 时:皮套色变 → 找同纹理 + 同条色(line)+ 新底色的头带,保留用户原本审美选择
// 优先级:① 原纹理 + 原条色 + 新底色  ② 原纹理 + 新底色 ③ solid + 新底色  ④ 任意新底色非占
function findLinkedHeadband(earpadColor, buildIdx) {
  if (!earpadColor) return null;
  const pool = getHeadbandPool(state.base.host);
  const otherSlug = state.builds[1 - buildIdx].headband;
  const currentHb = state.builds[buildIdx].headband;
  const candidates = [];

  if (currentHb) {
    const parts = currentHb.split('-');
    const series = parts[0];  // solid / line / totem / flower / quantum / ...
    if (series === 'line') {
      // line-{底色}-{条色}:保留条色优先
      const oldAccent = parts[2];
      candidates.push(`line-${earpadColor}-${oldAccent}`);
      // 同底色其他 line
      pool.filter(h => h.type === 'line' && getHeadbandBaseColor(h.slug) === earpadColor)
        .forEach(h => candidates.push(h.slug));
    } else {
      // solid / 设计款:同系列 + 新底色
      candidates.push(`${series}-${earpadColor}`);
    }
  }
  // fallback:solid + 新底色
  candidates.push(`solid-${earpadColor}`);
  // fallback:任意同底色
  pool.filter(h => getHeadbandBaseColor(h.slug) === earpadColor)
    .forEach(h => candidates.push(h.slug));

  for (const slug of candidates) {
    const obj = pool.find(h => h.slug === slug);
    if (obj && !obj.isBonus && slug !== otherSlug) return slug;
  }
  return null;
}
// linked 时:给定头带 slug 反推应配的皮套色(若头带底色是全包 4 色之一)
function findLinkedEarpad(headbandSlug, buildIdx) {
  const color = getHeadbandBaseColor(headbandSlug);
  if (!color || !EARPAD_COLORS.includes(color)) return null;
  const otherSlug = state.builds[1 - buildIdx].earpad;
  if (otherSlug === color) return null;  // 被另一副占了,放弃同步
  return color;
}

// Apple FAQ 风搭配规则卡片文案 — 根据 linked 状态和 build 索引动态生成
function buildLinkCardCopy(buildIdx) {
  const linked = state.headbandLinked;
  const b1ep = state.builds[0].earpad;
  const colorCn = b1ep ? getColor(b1ep).cn : '你选的皮套';
  // Build 1 还在装 → 不强调"避开"的事,只说同色规则;Build 2 才说"避开第 1 副"
  const isBuild2 = buildIdx === 1;
  if (linked) {
    const paras = isBuild2 && b1ep
      ? [
          `这是<strong>设计师推荐的搭配模式</strong>:头带和皮套<strong>同底色</strong>,出来的耳机<strong>整体感最强,99% 不踩雷</strong>。`,
          `第 1 副是<strong>「${colorCn}」主题</strong>,第 2 副我们已经把<strong>同底色头带自动收起</strong>,引导你挑<strong>另一种底色</strong> — 两副反差大,DIY 才出味道。`,
          `<strong>建议保持绑定</strong>。一旦解绑,头带和皮套就<strong>各管各</strong>,搭配很容易乱套,做出来的耳机大概率<strong>不好看</strong>。`,
        ]
      : [
          `这是<strong>设计师推荐的搭配模式</strong>:头带和皮套<strong>同底色</strong>,做出来的耳机<strong>整体感最强,99% 不踩雷</strong>。`,
          `选了头带,皮套<strong>自动跟色</strong>;反过来也一样。<strong>新手用这个模式最稳</strong>。`,
          `<strong>建议保持绑定</strong>。解绑后头带皮套各挑各的,稍不留神就会<strong>颜色打架</strong>,样品变难看。`,
        ];
    return {
      title: '头带已绑定皮套(推荐)',
      paras,
      action: '我还是想自己挑头带 ›',
    };
  }
  // 解绑态
  const paras = isBuild2 && b1ep
    ? [
        `自由发挥模式:<strong>43 款头带</strong>都能挑,可以跟第 1 副撞色,也可以异色。`,
        `提示:头带和皮套<strong>不同色</strong>其实<strong>很考验搭配功力</strong>,稍不留神整体就会<strong>显乱</strong>。如果不太有把握,建议<strong>回到智能搭配</strong>。`,
      ]
    : [
        `自由发挥模式:<strong>43 款头带</strong>都能挑,头带和皮套可以不同色。`,
        `提示:头带跟皮套<strong>不同色</strong>是<strong>审美的高阶玩法</strong>,搭不好<strong>容易乱</strong>。如果不太有把握,建议<strong>回到智能搭配</strong>。`,
      ];
  return {
    title: '头带独立挑选中',
    paras,
    action: '回到智能搭配 ›',
  };
}

/* ============================================================
   §9 ENUMERATE · 变体枚举(v13 · 从 builds 提取)
   ============================================================ */
// memo:同一帧 render 里 enumerate() 被 9 处调用,key 由 host + 2 副 build 的 7 个槽位拼出
// state 变 → key 变 → 重算;state 不变 → 直接返回缓存。state mutator 不必清缓存(key 自动失配)
let _enumerateMemo = { key: null, value: null };
function enumerate() {
  const host = state.base.host;
  const b0 = state.builds[0], b1 = state.builds[1];
  const memoKey = `${host}|${b0.faceplate}|${b0.earpad}|${b0.headband}|${b1.faceplate}|${b1.earpad}|${b1.headband}`;
  if (_enumerateMemo.key === memoKey) return _enumerateMemo.value;
  const halfEarpad   = LOCKED_PAIRS[host];          // 半包皮套(锁主机色)
  const lockedHb     = `solid-${halfEarpad}`;       // 标配纯色头带

  const fps = [b0.faceplate, b1.faceplate].filter(Boolean);
  const eps = [b0.earpad,    b1.earpad   ].filter(Boolean);
  const customHbs = [b0.headband, b1.headband].filter(Boolean);
  const headbands = [lockedHb, ...customHbs];       // 标配 + 加购 = 3 条(全装齐时)

  const variants = [];

  // 全包耳先排(图全, byBuild 标记的"亲手装"也都在这):1 × 面盖 × 皮套 × headbands
  if (fps.length && eps.length) {
    for (const fp of fps) for (const ep of eps) for (const hb of headbands) {
      let byBuild = -1;
      if (buildComplete(b0) && b0.faceplate === fp && b0.earpad === ep && b0.headband === hb) byBuild = 0;
      else if (buildComplete(b1) && b1.faceplate === fp && b1.earpad === ep && b1.headband === hb) byBuild = 1;
      variants.push({ form: 'overear', host, faceplate: fp, earpad: ep, headband: hb, byBuild });
    }
  }
  // 半包耳排后(皮套适配图缺,先放完整全包变体让第 1 张有图)
  for (const hb of headbands) {
    variants.push({ form: 'halfear', host, earpad: halfEarpad, faceplate: null, headband: hb, byBuild: -1 });
  }
  // 把"亲手装的第 1/2 副"(byBuild=0/1)排到最前,其余 13 串色按原枚举顺序排后(sort 稳定)
  variants.sort((a, b) => {
    const ar = a.byBuild >= 0 ? a.byBuild : 99;
    const br = b.byBuild >= 0 ? b.byBuild : 99;
    return ar - br;
  });
  _enumerateMemo = { key: memoKey, value: variants };
  return variants;
}

/* ============================================================
   §10 PRICE(v13 · 超级套装固定基价 + extras)
   ============================================================ */
function totalPrice() {
  // 超级套装:1 主机 + 标配 + 2 面盖 + 2 全包皮套 + 2 头带,固定基价
  let p = PRICE.base + PRICE.faceplate + PRICE.earpad + PRICE.headband;
  p += state.extras.extraHosts * PRICE.extraHost;
  if (state.extras.moniStrap) p += PRICE.moniStrap;
  return p;
}

/* ============================================================
   §11 LOOKUP HELPERS
   ============================================================ */
const $ = sel => document.querySelector(sel);
const HOST_MAP = Object.fromEntries(HOSTS.map(h => [h.slug, h]));
const EARPAD_MAP = Object.fromEntries(EARPADS.map(e => [e.slug, e]));

// 任意 slug 的色值/中文名(自动判断属于哪个池)
// fallback 时 warn,免 typo 把 slug 当中文名直接喷到 UI 上没人发现
function getColor(slug) {
  const hit = HOST_MAP[slug] || EARPAD_MAP[slug] || HEADBAND_MAP[slug];
  if (hit) return hit;
  console.warn(`[getColor] 未知 slug: ${slug}, 走 fallback`);
  return { cn: slug, hex: '#888' };
}

// Build 槽位定义:每副耳机要选 3 件(label 用图标 + tooltip,省横向空间)
const BUILD_SLOTS = [
  { key: 'headband',  label: '头带',    icon: '➰', type: 'headband', pool: () => getHeadbandPool(state.base.host) },
  { key: 'faceplate', label: '面盖',    icon: '◉', type: 'color',    pool: () => FACEPLATES },
  { key: 'earpad',    label: '全包皮套', icon: '◆', type: 'color',    pool: () => EARPADS },
];

/* ============================================================
   §12 RENDER
   ============================================================ */
let prevVariantsLen = 0;

function renderHero() {
  // v15.4 · 同步 .hero__faq 整张卡的展开/收起态(data-expanded 驱动 CSS)
  const faq   = $('.hero__faq');
  const guide = $('#hero-guide');
  if (faq && guide) {
    const open = state.heroGuideOpen;
    faq.setAttribute('data-expanded', open ? 'true' : 'false');
    faq.setAttribute('aria-expanded', open);
    if (open) guide.removeAttribute('hidden');
    else      guide.setAttribute('hidden', '');
  }
}

function renderVariants() {
  const allVariants = enumerate();
  // 2026-05-20:半包耳皮套 4 张 + 半包主机 4 张已到位,8 张缺口补齐
  // 全包耳 4 层 + 半包耳 3 层 PNG 都全,恢复 isFullVariant 过滤
  const variants = allVariants.filter(isFullVariant);
  const grid = $('#variants-grid');
  const grew = variants.length > prevVariantsLen;
  prevVariantsLen = variants.length;

  if (variants.length === 0) {
    grid.innerHTML = `<div class="variants__empty" style="flex:1;">先选满加购项的 2 个色 →</div>`;
    updateVariantsTrack();
    return;
  }

  // 一次性渲染全部变体(手指横滑切换),下方进度条根据 scroll 位置实时更新
  const pageItems = variants.map((v, i) => ({ v, idx: i }));
  // v15.33 · shadow 已经在 HTML 静态写在 .variants__strip 内,不再每次 render 都插进 grid
  grid.innerHTML = pageItems.map(({ v, idx: globalIdx }) => {
    // 4 层 PNG 适配图(缺图走 fallback 'none' → 该层透明)
    const imgHost = adaptImg('host', v.host, v.form);
    const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
    const imgEp   = adaptImg('earpad', v.earpad, v.form);
    const imgHb   = adaptImg('headband', v.headband, v.form);
    // 头带无适配图时,几何 fallback 用 hex 色显示一条头带横条
    const hbHex   = getColor(v.headband).hex;
    const hbFbCls = imgHb === 'none' ? ' is-fb' : '';
    // 👐 角标:byBuild=0/1 表示这个变体就是客户亲手装的那 2 副之一
    const handBadge = v.byBuild === 0 ? '<span class="variant__hand">👐 第1副</span>'
                    : v.byBuild === 1 ? '<span class="variant__hand">👐 第2副</span>'
                    : '';
    // 屏幕阅读器可读:形态 + 客户亲手装标记 + 4 件 cn 描述
    const ariaSegs = [v.form === 'overear' ? '全包耳' : '半包耳'];
    if (v.byBuild === 0) ariaSegs.push('你亲手装的第 1 副');
    else if (v.byBuild === 1) ariaSegs.push('你亲手装的第 2 副');
    const partSegs = [`头带${getColor(v.headband).cn}`, `主机${getColor(state.base.host).cn}`];
    if (v.faceplate) partSegs.push(`面盖${getColor(v.faceplate).cn}`);
    partSegs.push(`皮套${getColor(v.earpad).cn}`);
    const variantAria = `${ariaSegs.join(' · ')}:${partSegs.join('·')}`;
    return `
      <button class="variant glass-chip"
              data-idx="${globalIdx}"
              data-form="${v.form}"
              aria-pressed="${state.previewMode === 'library' && state.currentVariantIdx === globalIdx}"
              aria-label="${variantAria}"
              style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-headband:${hbHex};">
        <span class="variant__core">
          <span class="variant__layer variant__layer--shadow"></span>
          <span class="variant__layer variant__layer--earpad"></span>
          ${v.faceplate ? '<span class="variant__layer variant__layer--faceplate"></span>' : ''}
          <span class="variant__layer variant__layer--host"></span>
          <span class="variant__layer variant__layer--headband${hbFbCls}"></span>
        </span>
        <span class="variant__badge">${v.form === 'overear' ? '全包' : '半包'}</span>
        ${handBadge}
      </button>
    `;
  }).join('');

  grid.querySelectorAll('.variant').forEach((el) => {
    if (grew) el.classList.add('is-new');
    el.addEventListener('click', () => {
      const clickedIdx = +el.dataset.idx;
      // 修复-12 · 恢复 library mode toggle(用户重新明确要 carousel 横滚 + 一键批量下载)
      if (state.previewMode === 'library' && state.currentVariantIdx === clickedIdx) {
        state.previewMode = 'build';
      } else {
        state.currentVariantIdx = clickedIdx;
        state.previewMode = 'library';
        el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      render();
    });
  });

  // v15.33 · shadow 已固定在 .variants__strip 内,不再需要 JS 动态设宽
  updateVariantsTrack();
}

/* 进度条更新 · 嫁接-21.8:variants 不溢出时整条 track 隐藏(避免 thumb 100% 满铺像粗黑线) */
function updateVariantsTrack() {
  const grid = $('#variants-grid');
  const bar  = $('#variants-track-bar');
  if (!grid || !bar) return;
  const track = bar.parentElement;  // .variants__track
  const sw = grid.scrollWidth;
  const cw = grid.clientWidth;
  if (sw <= cw) {
    if (track) track.style.display = 'none';   // 不溢出时整条隐藏
    return;
  }
  if (track) track.style.display = '';
  const widthPct = (cw / sw) * 100;
  const posPct   = (grid.scrollLeft / sw) * 100;
  bar.style.setProperty('--track-w', widthPct + '%');
  bar.style.setProperty('--track-pos', posPct + '%');
}

// 渲染一张预览 card(4 层 PNG 叠加)
function renderPreviewCard(v, idx) {
  if (!v) return '';
  const imgHost = adaptImg('host', v.host, v.form);
  const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
  const imgEp   = adaptImg('earpad', v.earpad, v.form);
  const imgHb   = adaptImg('headband', v.headband, v.form);
  const epHex   = getColor(v.earpad).hex;
  return `
    <div class="preview-card" data-variant-idx="${idx}" data-form="${v.form}"
         style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-earpad-fb:${epHex};">
      <div class="preview-card__inner">
        <span class="preview-card__layer preview-card__layer--shadow"></span>
        <span class="preview-card__layer preview-card__layer--earpad"></span>
        <span class="preview-card__layer preview-card__layer--faceplate"></span>
        <span class="preview-card__layer preview-card__layer--host"></span>
        <span class="preview-card__layer preview-card__layer--headband"></span>
      </div>
    </div>
  `;
}

// 合成当前 Build 的"实时"变体对象(没装齐时降级半包)
function buildCurrentVariant() {
  const build = state.builds[state.activeBuild];
  const host = state.base.host;
  const halfEarpad = LOCKED_PAIRS[host];
  const lockedHb = `solid-${halfEarpad}`;
  const hasFull = build.faceplate && build.earpad;
  return hasFull ? {
    form: 'overear', host,
    faceplate: build.faceplate, earpad: build.earpad,
    headband: build.headband || lockedHb,
  } : {
    form: 'halfear', host,
    faceplate: null, earpad: halfEarpad,
    headband: build.headband || lockedHb,
  };
}

function renderPreview() {
  const variants = enumerate();
  const root = $('#preview');
  const carousel = $('#preview-carousel');
  const mode = state.previewMode;
  root.setAttribute('data-mode', mode);

  let currentV = null;
  if (mode === 'library' && variants.length) {
    // library 模式:渲染全部 variants → 3 张可视(中央 + 左右各 25%)
    if (state.currentVariantIdx >= variants.length) state.currentVariantIdx = 0;
    carousel.innerHTML = variants.map((v, i) => renderPreviewCard(v, i)).join('');
    currentV = variants[state.currentVariantIdx];
    // 渲染完 scroll 到当前 variant 居中(下一帧让 layout 算完)
    requestAnimationFrame(() => {
      const target = carousel.querySelector(`[data-variant-idx="${state.currentVariantIdx}"]`);
      target?.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
    });
  } else {
    // build 模式:只渲染 1 张当前 Build 的实时合成
    currentV = buildCurrentVariant();
    carousel.innerHTML = renderPreviewCard(currentV, -1);
  }

  if (!currentV) {
    root.removeAttribute('data-form');
    $('#preview-name').textContent = '— 暂无变体 —';
    $('#preview-caption').textContent = 'PREVIEW';
    $('#preview-sub-caption').textContent = '';
    $('#preview-tagline').textContent = '';
    $('#preview-leadin').textContent = '';
    return;
  }

  root.setAttribute('data-form', currentV.form);
  $('#preview-name').innerHTML = previewNameHTML(currentV);
  const subCaption = $('#preview-sub-caption');
  const tagline = $('#preview-tagline');
  const leadin = $('#preview-leadin');
  if (mode === 'library') {
    // 搭配库模式:维持原"第 X / Y 套"紧凑标签,eyebrow / tagline / leadin 清空隐藏
    $('#preview-caption').textContent = `搭配库 · 第 ${state.currentVariantIdx + 1} / ${variants.length} 套`;
    subCaption.textContent = '';
    tagline.textContent = '';
    leadin.textContent = '';
  } else {
    // v15.19 · DIY 模式:Apple 牌坊风 4 段(eyebrow → 主标 → tagline 2行 → leadin 问句 → 预览图)
    subCaption.textContent = '一切搭配,从这一步开始';
    $('#preview-caption').textContent = '设计你的 Rainbow';
    tagline.textContent = '选一台主机,接着换头带、面盖与皮套。\n每一步都能实时预览,装错也来得及调。';
    leadin.textContent = '准备好了吗?';
  }
  fillMeta(currentV);
}

// 修复-16 · 竖长方形产品图风排版(1500×2000 / 浅灰底 / 耳机居中占 60% / 上下留白)
function composeVariantPng(v) {
  return new Promise(resolve => {
    const W = 1500, H = 2000;
    const earSize = 900;                  // 耳机绘制方块尺寸(占 width 60%)
    const offsetX = Math.floor((W - earSize) / 2);  // 水平居中
    const offsetY = Math.floor((H - earSize) / 2);  // 垂直居中(上下各留 550)
    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    // 浅灰底(产品图常用)
    ctx.fillStyle = '#F0F0F0';
    ctx.fillRect(0, 0, W, H);
    // 5 层 raw URL 拼接(跳过 adaptImg 的 url() 包装)
    const halfSuffix = v.form === 'halfear' ? '-halfear' : '';
    const sources = [
      cdnUrl('素材/适配图/shadow.png'),
      cdnUrl(`素材/适配图/earpad${(v.form === 'halfear') ? '-halfear' : ''}-${v.earpad}.png`),
      v.faceplate ? cdnUrl(`素材/适配图/faceplate-${v.faceplate}.png`) : null,
      cdnUrl(`素材/适配图/host${halfSuffix}-${v.host}.png`),
      cdnUrl(`素材/适配图/headband-${v.headband}.png`),
    ];
    const loadOne = src => new Promise(res => {
      if (!src) return res(null);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => res(img);
      img.onerror = () => { console.warn('[compose] 加载失败:', src); res(null); };
      img.src = src;
    });
    Promise.all(sources.map(loadOne)).then(images => {
      for (const img of images) {
        if (img) ctx.drawImage(img, offsetX, offsetY, earSize, earSize);
      }
      canvas.toBlob(blob => resolve(blob), 'image/png');
    });
  });
}

// 修复-15 · 直接下载 N 张 PNG(浏览器逐张触发,不打包 zip)
async function downloadAllVariantsZip() {
  const btn = $('#explore-download');
  btn.classList.add('is-loading');
  try {
    const variants = enumerate();
    for (let i = 0; i < variants.length; i++) {
      const v = variants[i];
      const blob = await composeVariantPng(v);
      if (!blob) continue;
      const idx = String(i + 1).padStart(2, '0');
      const fp = v.faceplate || 'half';
      const fname = `rainbow-${idx}-host${v.host}-hb${v.headband}-fp${fp}-ep${v.earpad}.png`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fname;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 延时 200ms 避免浏览器拒绝连续触发
      await new Promise(r => setTimeout(r, 200));
      URL.revokeObjectURL(url);
    }
  } catch (e) {
    console.error('[批量下载] 失败:', e);
    alert('下载出错,请重试');
  } finally {
    btn.classList.remove('is-loading');
  }
}

// 主图下方文字:固定顺序 主机 → 头带 → 面盖 → 皮套,色点直接用适配图(取真色,hex 兜底)
function previewNameHTML(v) {
  const items = [
    { slug: v.host,     label: '主机', type: 'host' },
    { slug: v.headband, label: '头带', type: 'headband' },
    v.faceplate ? { slug: v.faceplate, label: '面盖', type: 'faceplate' } : null,
    { slug: v.earpad,   label: '皮套', type: 'earpad' },
  ].filter(Boolean);
  // v15.16 · 加配件名前缀("主机:" / "头带:" / "面盖:" / "皮套:")· 一行紧凑显示
  return items.map(it => {
    const c = getColor(it.slug);
    const img = adaptImg(it.type, it.slug, v.form);
    return `<span class="preview-name__item">
      <span class="preview-name__dot" style="--c:${c.hex}; --img:${img};"></span><span class="preview-name__label">${it.label}:</span>${c.cn}
    </span>`;
  }).join('<span class="preview-name__sep">·</span>');
}

// 竖向白卡内容:4 行清单(头带/主机/面盖/皮套),每行 [色点 + 类别 label + 色名]
function fillMeta(v) {
  const meta = $('#preview-meta');
  if (!v) { meta.innerHTML = ''; return; }
  const rows = [
    { label: '头带', slug: v.headband },
    { label: '主机', slug: v.host },
    v.faceplate ? { label: '面盖', slug: v.faceplate } : null,
    { label: '皮套', slug: v.earpad },
  ].filter(Boolean);
  meta.innerHTML = rows.map(r => {
    const c = getColor(r.slug);
    return `<div class="preview__meta-row">
      <span class="preview__meta-row__dot" style="--c:${c.hex};"></span>
      <span class="preview__meta-row__label">${r.label}</span>
      <span class="preview__meta-row__name">${c.cn}</span>
    </div>`;
  }).join('');
}

function renderHostBar() {
  const left = $('#host-bar-left');
  const right = $('#host-bar-right');
  if (!left || !right) return;
  const chipsHTML = HOSTS.map(h => {
    // 完整迷你耳机预览:3 层 PNG 叠(头带+主机+半包皮套,按 LOCKED_PAIRS 取该主机色的标配)
    const lockedColor = LOCKED_PAIRS[h.slug];
    const imgHb   = adaptImg('headband', `solid-${lockedColor}`, 'halfear');
    const imgHost = adaptImg('host',     h.slug,                  'halfear');
    const imgEp   = adaptImg('earpad',   lockedColor,             'halfear');
    return `
    <button class="host-chip" data-host="${h.slug}"
            aria-pressed="${state.base.host === h.slug}"
            aria-label="主机 ${h.cn}"
            style="--img-hb:${imgHb}; --img-host:${imgHost}; --img-ep:${imgEp};">
      <span class="host-chip__swatch">
        <span class="host-chip__layer host-chip__layer--ep"></span>
        <span class="host-chip__layer host-chip__layer--host"></span>
        <span class="host-chip__layer host-chip__layer--hb"></span>
      </span>
      <span class="host-chip__name">${h.cn}</span>
    </button>
  `;
  });
  // 左侧前 2 个(星空银 / 大漠黄),右侧后 2 个(静谧蓝 / 复古绿)
  left.innerHTML = chipsHTML.slice(0, 2).join('');
  right.innerHTML = chipsHTML.slice(2, 4).join('');
  // 事件绑定:左右容器统一绑
  const bar = { querySelectorAll: (sel) => [
    ...left.querySelectorAll(sel),
    ...right.querySelectorAll(sel),
  ]};
  bar.querySelectorAll('[data-host]').forEach(el => {
    el.addEventListener('click', () => {
      state.base.host = el.dataset.host;
      syncBuildsAfterHostChange();
      // 主图自动切到包含新 host 的 4 层全 PNG 变体
      selectVariantBy('host', el.dataset.host);
      render();
    });
  });
}

// 主机切了 → 标配头带 slug 变了 → Build 1/2 里若有人选了"新主机的标配纯色头带",清掉
function syncBuildsAfterHostChange() {
  const lockedSolid = `solid-${LOCKED_PAIRS[state.base.host]}`;
  state.builds.forEach(b => {
    if (b.headband === lockedSolid) b.headband = null;
  });
}

function renderKit() {
  const list = $('#kit-list');
  list.innerHTML = '';
  const lockedColor = LOCKED_PAIRS[state.base.host];

  // v15.9 · 顶部锁色说明完全去除(用户要求)
  $('#locked-note-slot').innerHTML = '';

  // —— 2. 装 2 副 DIY · Tab 合并版(两副共用 1 个玻璃卡) ——
  const isB1Done = buildComplete(state.builds[0]);
  // 如果 Build 1 没完成且当前在编辑 Build 2,自动切回 Build 1
  if (!isB1Done && state.activeBuild === 1) state.activeBuild = 0;
  const activeBuildIdx = state.activeBuild;
  const activeBuild = state.builds[activeBuildIdx];
  const activeLocked = activeBuildIdx === 1 && !isB1Done;

  const li = document.createElement('li');
  li.className = 'kit-item kit-item--build kit-item--build-tabs';
  li.setAttribute('aria-checked', 'true');
  li.setAttribute('data-active-build', activeBuildIdx);

  li.innerHTML = `
    <!-- v15.74 · 顺序调换:Tab 横排切换 → link-card,把"装第 1/2 副"提到顶端 -->
    <!-- Tab 横排切换 -->
    <div class="build-tabs__bar" role="tablist">
      ${[0, 1].map(i => {
        const b = state.builds[i];
        const done = buildComplete(b);
        const tabLocked = i === 1 && !isB1Done;
        const cnt = [b.faceplate, b.headband, b.earpad].filter(Boolean).length;
        const label = i === 0 ? '装第 1 副' : '装第 2 副';
        const subLabel = done ? '<span class="build-tabs__tab-check">✓</span>' : tabLocked ? '🔒' : `还差 ${3 - cnt} 件`;
        // v15.8 · 删 "改" 和 "+" 按钮(上方 picker 已能同步配件,无需重复入口)
        const tools = '';
        return `
          <div class="build-tabs__tab ${tabLocked ? 'is-locked' : ''}" role="tab" data-build-tab="${i}"
               aria-selected="${i === activeBuildIdx}">
            <span class="build-tabs__tab-label">${label}</span>
            <span class="build-tabs__tab-state">${subLabel}</span>
            ${tools}
          </div>
        `;
      }).join('')}
    </div>

    <!-- v15.74 · link-card 调到 build-tabs__bar 下方 -->
    ${renderLinkCard(activeBuildIdx)}

    <!-- "+" 展开后显示装好内容(横跨 2 个 tab 下方) -->
    ${[0, 1].map(i => {
      const b = state.builds[i];
      if (!buildComplete(b) || !state.detailsOpen[i]) return '';
      const parts = [getColor(b.faceplate).cn + '面盖', getColor(b.headband).cn + '头带', getColor(b.earpad).cn + '全包皮套'];
      return `
        <div class="build-tabs__details" data-build="${i}">
          <span class="build-tabs__details-tag">第 ${i + 1} 副:</span>
          <span class="build-tabs__details-parts">${parts.join(' · ')}</span>
        </div>
      `;
    }).join('')}

    <!-- 当前 tab 的 3 行 picker -->
    <div class="build-tabs__panel" data-build="${activeBuildIdx}">
      ${activeLocked
        ? '<div class="kit-item__lock-overlay--inline"><span>🔒 先装好第 1 副</span></div>'
        : BUILD_SLOTS.map(slot => renderSlotPicker(activeBuildIdx, slot)).join('')}
    </div>
  `;
  list.appendChild(li);

  // —— 阶段 A · 魔尼带 li(独立行,全套装 1 件,锁色联动 Build 1 皮套 + 解锁按钮) ——
  const moniLi = document.createElement('li');
  moniLi.className = 'kit-item kit-item--moni-strap';
  const activeMoniSlug = getMoniStrapSlug();
  const moniLinked = state.moniStrap.linked;
  const linkedColor = state.builds[0].earpad; // linked 时显示的"被锁的色"
  moniLi.innerHTML = `
    <div class="moni-strap-row">
      <div class="moni-strap-row__head">
        <span class="moni-strap-row__icon" aria-hidden="true">🎗️</span>
        <span class="moni-strap-row__label">魔尼带</span>
        <span class="moni-strap-row__sub">套装内 1 件</span>
        <button class="moni-strap-row__lock" type="button"
                data-toggle-moni-lock
                aria-pressed="${moniLinked}"
                title="${moniLinked ? '已锁色到 Build 1 皮套,点击解锁自由选' : '已解锁自由选,点击锁回 Build 1 皮套色'}">
          ${moniLinked ? '🔒 锁色' : '🔓 自由'}
        </button>
      </div>
      <div class="moni-strap-row__chips inline-picker">
        ${MONI_STRAPS.map(m => {
          const isSel = activeMoniSlug === m.slug;
          // linked 模式下:只有跟 Build 1 皮套色一致的 chip 选中,其他 chip 灰禁(提示用户解锁才能选)
          const isLockedOut = moniLinked && linkedColor && m.slug !== linkedColor;
          const imgStyle = m.image ? ` --img:url('${m.image}');` : '';
          const disAttr = isLockedOut ? ' disabled data-locked-by-build1="true"' : '';
          const title = isLockedOut ? `${m.cn}(解锁后可选)` : m.cn;
          return `
            <button class="picker-chip picker-chip--moni" data-pick="${m.slug}" data-slot="moni"${disAttr}
                    aria-pressed="${isSel}"
                    aria-label="魔尼带 ${title}"
                    title="${title}"
                    style="--c:${m.hex};${imgStyle}">
              <span class="picker-chip__swatch picker-chip__swatch--transparent"></span>
              <span class="picker-chip__name">${m.cn}</span>
            </button>
          `;
        }).join('')}
      </div>
    </div>
  `;
  list.appendChild(moniLi);

  // 魔尼带 chip click(自由模式下选色)
  moniLi.querySelectorAll('.picker-chip[data-slot="moni"]').forEach(chip => {
    chip.addEventListener('click', (e) => {
      e.stopPropagation();
      if (chip.disabled) return;
      const slug = chip.dataset.pick;
      state.moniStrap.slug = slug;
      // linked 状态下手动改色 → 自动解锁(因为 linked 应该跟皮套走,用户改色 = 想脱离锁定)
      if (state.moniStrap.linked) state.moniStrap.linked = false;
      render();
    });
  });
  // 锁/解锁按钮
  moniLi.querySelectorAll('[data-toggle-moni-lock]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      state.moniStrap.linked = !state.moniStrap.linked;
      // 锁回去 → state.moniStrap.slug 自动跟 Build 1 皮套同色(下次 render 调 getMoniStrapSlug 自动)
      if (state.moniStrap.linked && state.builds[0].earpad) {
        state.moniStrap.slug = state.builds[0].earpad;
      }
      render();
    });
  });

  // —— 事件绑定 ——
  // Tab 切换(点 tab 本身,但要避开 "改" 和 "+" 子按钮)
  li.querySelectorAll('[data-build-tab]').forEach(tab => {
    tab.addEventListener('click', (e) => {
      if (e.target.closest('[data-reset-build]') || e.target.closest('[data-toggle-info]')) return;
      e.stopPropagation();
      if (tab.classList.contains('is-locked')) return;
      const newIdx = +tab.dataset.buildTab;
      // 切到不同 Build 时:重新定位头带 picker
      if (state.activeBuild !== newIdx) {
        const newBuild = state.builds[newIdx];
        if (newBuild.headband && HEADBAND_MAP[newBuild.headband]) {
          // 该 Build 已选头带 → 滚到该 chip 居中
          state.headbandTab = HEADBAND_MAP[newBuild.headband].type;
          state.headbandScrollTo = newBuild.headband;
          state.headbandScrollMode = 'center';
        } else {
          // 该 Build 未选 → 用 'start' 模式把线条款第 1 条推到最左,后面 3 条同类一起露出(刚好 4 个一屏)
          state.headbandTab = 'line';
          const firstLine = ALL_HEADBANDS.find(h => h.type === 'line');
          if (firstLine) {
            state.headbandScrollTo = firstLine.slug;
            state.headbandScrollMode = 'start';
          }
        }
        state.headbandScrollLeft = 0;
      }
      state.activeBuild = newIdx;
      state.previewMode = 'build';   // 切 Tab → 主图跟随新 Build 预览
      render();
    });
  });

  // "改" 按钮:清空对应 build + 切到那副重选
  li.querySelectorAll('[data-reset-build]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const idx = +btn.dataset.resetBuild;
      state.builds[idx] = { faceplate: null, headband: null, earpad: null };
      state.detailsOpen[idx] = false;  // 一并收起 details
      state.activeBuild = idx;
      state.headbandScrollLeft = 0;     // 重选 → 头带回到第一条
      render();
    });
  });

  // "+" 按钮:toggle 展开装好内容(在 Tab 下方推开文字)
  li.querySelectorAll('[data-toggle-info]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const idx = +btn.dataset.toggleInfo;
      state.detailsOpen[idx] = !state.detailsOpen[idx];
      render();
    });
  });

  if (!activeLocked) {
    // 普通色卡 chip 单选(面盖/皮套) — 仅当前 tab 的 picker
    // v15.55 · 改用 picker-chip 类(跟头带统一造型),用 data-slot 区分,跳过头带槽位
    li.querySelectorAll('.picker-chip[data-slot="faceplate"], .picker-chip[data-slot="earpad"]').forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        if (chip.disabled) return;
        const slot = chip.dataset.slot;
        const slug = chip.dataset.pick;
        state.builds[activeBuildIdx][slot] = (state.builds[activeBuildIdx][slot] === slug) ? null : slug;
        // linked + 选了皮套 → 同步头带(同纹理 + 同条色 + 新底色),并请求 picker 滚到新 chip
        if (state.headbandLinked && slot === 'earpad' && state.builds[activeBuildIdx].earpad) {
          const linkedHb = findLinkedHeadband(state.builds[activeBuildIdx].earpad, activeBuildIdx);
          if (linkedHb) {
            state.builds[activeBuildIdx].headband = linkedHb;
            state.headbandScrollTo = linkedHb;
          }
        }
        state.previewMode = 'build';
        render();
      });
    });

    // 头带 chip 单选(限定 data-slot="headband",防绑到面盖/皮套同类 chip)
    li.querySelectorAll('.picker-chip[data-slot="headband"]').forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.stopPropagation();
        if (chip.disabled) return;
        const slug = chip.dataset.pick;
        state.builds[activeBuildIdx].headband = (state.builds[activeBuildIdx].headband === slug) ? null : slug;
        // linked + 选了头带 → 反向同步皮套为同底色(若底色是全包 4 色之一)
        if (state.headbandLinked && state.builds[activeBuildIdx].headband) {
          const linkedEp = findLinkedEarpad(state.builds[activeBuildIdx].headband, activeBuildIdx);
          if (linkedEp) state.builds[activeBuildIdx].earpad = linkedEp;
        }
        state.previewMode = 'build';
        render();
      });
    });

    // 头带 + 帮助按钮:toggle 展开说明
    li.querySelectorAll('[data-toggle-link-help]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        state.headbandLinkHelpOpen = !state.headbandLinkHelpOpen;
        render();
      });
    });
    // 解绑 / 重新绑定切换:翻转 linked,重新绑定时立即把头带改成当前皮套同色
    li.querySelectorAll('[data-toggle-linked]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        state.headbandLinked = !state.headbandLinked;
        if (state.headbandLinked) {
          const ep = state.builds[activeBuildIdx].earpad;
          if (ep) {
            const linkedHb = findLinkedHeadband(ep, activeBuildIdx);
            if (linkedHb) state.builds[activeBuildIdx].headband = linkedHb;
          }
        }
        render();
      });
    });

    // 头带横滑:更新进度条位置 + 同步 state.headbandTab(隐性,用于 render 状态保持)
    const hbScroll = li.querySelector('[data-headband-scroll]');
    const hbTrack = li.querySelector('[data-headband-track]');
    // render 后头带 picker 位置处理:① 有 scrollTo 请求 → 居中滚到目标 chip;② 否则恢复之前的横滑位置
    if (hbScroll) {
      if (state.headbandScrollTo) {
        const mode = state.headbandScrollMode || 'center';
        requestAnimationFrame(() => {
          const target = hbScroll.querySelector(`.picker-chip[data-pick="${state.headbandScrollTo}"]`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', inline: mode, block: 'nearest' });
            setTimeout(() => { state.headbandScrollLeft = hbScroll.scrollLeft; }, 320);
          }
          state.headbandScrollTo = null;
          state.headbandScrollMode = 'center';
        });
      } else if (state.headbandScrollLeft > 0) {
        hbScroll.scrollLeft = state.headbandScrollLeft;
      }
    }
    if (hbScroll && hbTrack) {
      const trackContainer = hbTrack.parentElement;  // .picker-track,点击/拖动区
      const updateTrackAndTab = () => {
        const sw = hbScroll.scrollWidth - hbScroll.clientWidth;
        // 进度条
        if (sw > 0) {
          const ratio = hbScroll.scrollLeft / sw;
          const visibleRatio = hbScroll.clientWidth / hbScroll.scrollWidth;
          // thumb 宽度按可视占比,但留出"thumb 自己"的活动范围(thumb 在 track 内左右移)
          const thumbWidthPct = Math.max(15, visibleRatio * 100);
          hbTrack.style.setProperty('--track-w', `${thumbWidthPct}%`);
          hbTrack.style.setProperty('--track-pos', `${ratio * (100 - thumbWidthPct)}%`);
        } else {
          hbTrack.style.setProperty('--track-pos', '0%');
          hbTrack.style.setProperty('--track-w', '100%');
        }
        // 找当前可视区左边第一个完整 chip 的 type
        const rowRect = hbScroll.getBoundingClientRect();
        const chips = [...hbScroll.querySelectorAll('.picker-chip')];
        let activeType = chips[0]?.dataset.type || 'design';
        for (const chip of chips) {
          const r = chip.getBoundingClientRect();
          // 取中央对齐 row 中央的 chip 作为 active
          if (r.right - 10 >= rowRect.left) {
            activeType = chip.dataset.type;
            break;
          }
        }
        // 同步 state.headbandTab(隐性记录,无 UI 输出)
        if (state.headbandTab !== activeType) {
          state.headbandTab = activeType;
        }
        // 记当前横滑位置,下次 render 后立即恢复
        state.headbandScrollLeft = hbScroll.scrollLeft;
      };
      hbScroll.addEventListener('scroll', updateTrackAndTab, { passive: true });
      requestAnimationFrame(updateTrackAndTab);

      // ── 嫁接-21.7 · slider 可交互:点击 picker-track 任意位置 → 头带瞬移;按住 + 拖动 → 实时滚 ──
      if (trackContainer) {
        // 绝对位置映射:click x 占 track 宽的比例 = 头带滚动比例(无需 thumb 宽度参与)
        const seekFromX = (clientX) => {
          const rect = trackContainer.getBoundingClientRect();
          if (rect.width <= 0) return;
          const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
          const sw = hbScroll.scrollWidth - hbScroll.clientWidth;
          if (sw > 0) {
            hbScroll.scrollLeft = sw * ratio;
            updateTrackAndTab();  // 嫁接-21.8 · 立即同步 thumb,不等浏览器 scroll 事件回调延迟
          }
        };
        let dragging = false;
        let pointerId = null;
        let rafId = null;
        let pendingX = 0;
        const flush = () => {
          rafId = null;
          seekFromX(pendingX);
        };
        const schedule = (x) => {
          pendingX = x;
          if (rafId == null) rafId = requestAnimationFrame(flush);
        };
        const onDown = (e) => {
          if (e.button !== undefined && e.button !== 0) return;
          e.preventDefault();
          dragging = true;
          pointerId = e.pointerId;
          trackContainer.classList.add('is-dragging');
          try { trackContainer.setPointerCapture(pointerId); } catch (_) {}
          seekFromX(e.clientX);  // 点击立即跳
        };
        const onMove = (e) => {
          if (!dragging) return;
          e.preventDefault();
          schedule(e.clientX);    // rAF 节流跟手
        };
        const onUp = () => {
          if (!dragging) return;
          dragging = false;
          trackContainer.classList.remove('is-dragging');
          if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
          try { trackContainer.releasePointerCapture(pointerId); } catch (_) {}
          pointerId = null;
        };
        trackContainer.addEventListener('pointerdown', onDown);
        trackContainer.addEventListener('pointermove', onMove);
        trackContainer.addEventListener('pointerup', onUp);
        trackContainer.addEventListener('pointercancel', onUp);
      }
    }
  }

  // —— 多加主机 + 魔尼带:已下线主流程,改进阶段 C 的 "升级方案 ›" 弹窗(state.extras 保留) ——
  // 历史代码见 快照/index-2026-05-18-v12-引导前.html
}

// ── v13 · Tab 头部:两副 mini 卡常驻(完成则显示缩略图,未完成则显示占位 + "正在装") ──
function renderBuildMiniCardSlot(buildIdx) {
  const build = state.builds[buildIdx];
  const isB1Done = buildComplete(state.builds[0]);
  const locked = buildIdx === 1 && !isB1Done;
  const done = buildComplete(build);
  const isActive = state.activeBuild === buildIdx && !locked;
  if (done) return renderBuildMiniCard(buildIdx, build, isActive);
  return `
    <div class="build-card build-card--placeholder ${locked ? 'is-locked' : ''} ${isActive ? 'is-active' : ''}">
      <div class="build-card__thumb build-card__thumb--placeholder">
        ${locked ? '🔒' : (isActive ? '✏️' : '○')}
      </div>
      <div class="build-card__body">
        <div class="build-card__title build-card__title--placeholder">
          ${locked ? `第 ${buildIdx + 1} 副待装` : (isActive ? `正在装第 ${buildIdx + 1} 副` : `第 ${buildIdx + 1} 副待装`)}
        </div>
        <div class="build-card__parts">${locked ? '先装好第 1 副' : '挑 3 件零件'}</div>
      </div>
    </div>
  `;
}

// ── v13 · build 完成后的定型卡(顶部冒出,4 层缩略图 + 文字 + "改" 链接)──
function renderBuildMiniCard(buildIdx, build, isActive) {
  const host = state.base.host;
  const imgHost = adaptImg('host',      host,           'overear');
  const imgFp   = adaptImg('faceplate', build.faceplate,'overear');
  const imgEp   = adaptImg('earpad',    build.earpad,   'overear');
  const imgHb   = adaptImg('headband',  build.headband, 'overear');
  const hbHex   = getColor(build.headband).hex;
  const parts = [
    getColor(build.faceplate).cn,
    getColor(build.headband).cn,
    getColor(build.earpad).cn,
  ].join(' · ');
  return `
    <div class="build-card ${isActive ? 'is-active' : ''}">
      <div class="build-card__thumb"
           style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-headband:${hbHex};">
        <span class="build-card__layer build-card__layer--shadow"></span>
        <span class="build-card__layer build-card__layer--earpad"></span>
        <span class="build-card__layer build-card__layer--faceplate"></span>
        <span class="build-card__layer build-card__layer--host"></span>
        <span class="build-card__layer build-card__layer--headband"></span>
      </div>
      <div class="build-card__body">
        <div class="build-card__title">✅ 第 ${buildIdx + 1} 副</div>
        <div class="build-card__parts">${parts}</div>
      </div>
      <button class="build-card__reset" data-reset-build="${buildIdx}" title="清空重选">改</button>
    </div>
  `;
}

// ── v13 · Build 槽位 picker 调度:所有槽位统一 block 模式(icon 在上,chip 横排在下,3 行左对齐) ──
function renderSlotPicker(buildIdx, slot) {
  const pool = slot.pool();
  if (slot.type === 'color') {
    return `
      <div class="slot-row slot-row--block" data-slot="${slot.key}">
        <div class="slot-row__head">
          <span class="slot-row__icon" title="${slot.label}">${slot.icon}</span>
          <span class="slot-row__label-text">${slot.label}</span>
        </div>
        <div class="slot-row__chips inline-picker">
          ${renderInlineChips(buildIdx, slot.key, pool)}
        </div>
      </div>
    `;
  }
  // headband:head 行带 label-text 跟面盖/皮套 head 同高(对齐 3 行 chip Y 位置);link-card 在 renderKit 顶部独立
  return `
    <div class="slot-row slot-row--block" data-slot="${slot.key}">
      <div class="slot-row__head">
        <span class="slot-row__icon" title="${slot.label}">${slot.icon}</span>
        <span class="slot-row__label-text">${slot.label}</span>
      </div>
      ${renderHeadbandGridHTML(buildIdx, pool)}
    </div>
  `;
}

// v15.15 · 头带↔皮套 绑定规则 link-card(从 renderSlotPicker 抽出,供 renderKit 顶部独立调用)
function renderLinkCard(buildIdx) {
  const helpOpen = state.headbandLinkHelpOpen;
  const copy = buildLinkCardCopy(buildIdx);
  return `
    <div class="link-card" data-expanded="${helpOpen ? 'true' : 'false'}">
      <div class="link-card__title">${copy.title}</div>
      ${helpOpen ? `
        <div class="link-card__body">
          ${copy.paras.map(p => `<p>${p}</p>`).join('')}
          <button class="link-card__link" type="button" data-toggle-linked>${copy.action}</button>
        </div>
      ` : ''}
      <button class="link-card__plus" type="button" data-toggle-link-help
              aria-expanded="${helpOpen}" aria-label="${helpOpen ? '收起' : '展开'}搭配规则说明">
        <svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true">
          <path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/>
        </svg>
      </button>
    </div>
  `;
}

// 同行 mini 色点(面盖 / 皮套,单选模型,防重复)
// v15.55 · 复用 picker-chip 结构(swatch + name),跟头带 chip 视觉造型完全一致(都带名字标签,等高)
function renderInlineChips(buildIdx, slotKey, pool) {
  const selected = state.builds[buildIdx][slotKey];
  const otherSlug = state.builds[1 - buildIdx][slotKey];
  return pool.map(c => {
    const isSel = selected === c.slug;
    // 被另一副占用 → 禁选 (防重复,确保 2 副耳机外观不同)
    const isUsedByOther = otherSlug && otherSlug === c.slug;
    const imgStyle = c.image ? ` --img:url('${c.image}');` : '';
    const swatchCls = c.image ? 'picker-chip__swatch picker-chip__swatch--transparent' : 'picker-chip__swatch';
    const disAttr = isUsedByOther ? ' disabled data-used-by-other="true"' : '';
    const title = isUsedByOther ? `${c.cn}(已被另一副选用)` : c.cn;
    const slotCn = slotKey === 'faceplate' ? '面盖' : '皮套';
    return `
      <button class="picker-chip" data-pick="${c.slug}" data-slot="${slotKey}"${disAttr}
              aria-pressed="${isSel}"
              aria-label="${slotCn} ${title}"
              data-pick-order="${isSel ? '✓' : ''}"
              title="${title}"
              style="--c:${c.hex};${imgStyle}">
        <span class="${swatchCls}"></span>
        <span class="picker-chip__name">${c.cn}</span>
      </button>
    `;
  }).join('');
}

// 头带 tabs(design / line / solid 三类切换;Build 1/2 共享 state.headbandTab)
function headbandGroups(pool) {
  return {
    design: pool.filter(h => h.type === 'design'),
    line:   pool.filter(h => h.type === 'line'),
    solid:  pool.filter(h => h.type === 'solid'),
  };
}
// 头带 strip · 全 44 chip 一字铺(4 纯色 + 8 线条 + 32 设计),横滑 + scroll-snap,tab 跟随当前滑到的分类自动高亮
const HEADBAND_VISIBLE = 4;
function renderHeadbandGridHTML(buildIdx, pool) {
  const g = headbandGroups(pool);
  const allChips = [...g.design, ...g.line, ...g.solid];  // 一字铺,按 design→line→solid 顺序
  const selected = state.builds[buildIdx].headband;
  const otherSlug = state.builds[1 - buildIdx].headband;
  const total = allChips.length;
  const trackW = total > 0 ? Math.max(15, (HEADBAND_VISIBLE / total) * 100) : 100;
  return `
    <div class="picker-strip">
      <button class="picker-strip__arrow picker-strip__arrow--prev" type="button" aria-label="上一组头带" data-headband-arrow="prev"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>
      <div class="picker-strip__main">
        <div class="picker-row" data-headband-scroll>
          ${allChips.map(h => {
            // 智能避撞:Build 2 + linked → 跟 Build 1 皮套同底色的头带禁选
            const lockedColor = (state.headbandLinked && buildIdx === 1) ? state.builds[0].earpad : null;
            const isSel = selected === h.slug;
            const isUsedByOther = otherSlug && otherSlug === h.slug;
            const isBonus = h.isBonus;        // 标配头带(锁主机色,套装内已含)
            const isSameColorAsB1 = lockedColor && getHeadbandBaseColor(h.slug) === lockedColor;
            const imgStyle = h.image ? ` --img:url('${h.image}');` : '';
            const disAttr = (isUsedByOther || isBonus || isSameColorAsB1)
              ? ` disabled${isBonus ? ' data-bonus="true"' : isSameColorAsB1 ? ' data-same-color="true"' : ' data-used-by-other="true"'}`
              : '';
            const titleText = isBonus ? `${h.cn}(套装标配,不可选 / 已含)`
                            : isSameColorAsB1 ? `${h.cn}(跟第 1 副同底色,会让两副看着像同一款)`
                            : isUsedByOther ? `${h.cn}(已被另一副选用)` : h.cn;
            const bonusBadge = isBonus ? '<span class="picker-chip__bonus" title="标配,已包含在套装内">标</span>' : '';
            const baseColor = getHeadbandBaseColor(h.slug);
            return `
              <button class="picker-chip" data-pick="${h.slug}" data-slot="headband" data-type="${h.type}" data-base-color="${baseColor}"${disAttr}
                      aria-pressed="${isSel}"
                      aria-label="头带 ${titleText}"
                      data-pick-order="${isSel ? '✓' : ''}"
                      title="${titleText}"
                      style="--c:${h.hex}; --c-accent:${h.accentHex};${imgStyle}">
                <span class="picker-chip__swatch${h.image ? ' picker-chip__swatch--transparent' : ''}"></span>
                ${bonusBadge}
                <span class="picker-chip__name">${h.cn}</span>
              </button>
            `;
          }).join('')}
        </div>
        <div class="picker-track">
          <div class="picker-track__bar" data-headband-track style="--track-pos:0%; --track-w:${trackW}%;"></div>
        </div>
      </div>
      <button class="picker-strip__arrow picker-strip__arrow--next" type="button" aria-label="下一组头带" data-headband-arrow="next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>
    </div>
  `;
}

function renderCta() {
  const btn  = $('#add-to-cart');
  const main = $('#cta-main');
  const hint = $('#cta-hint');
  const n     = state.kitCount || 2;            // 当前选的副数
  const price = totalPriceMvp();                // 当前总价
  $('#total-price').textContent = '$' + price;  // 旧节点保留(已 CSS 隐藏)

  // 嫁接-21.13 · 防呆 A:按 kitCount 跨副检查,任意一副空就禁用 + 提示去装那副
  const buildsNeeded = state.builds.slice(0, n);
  const incompleteIdx = buildsNeeded.findIndex(b => !buildComplete(b));

  if (incompleteIdx === -1) {
    // 前 n 副全装好
    btn.disabled = false;
    main.textContent = `加入购物车 · ${n} 副 →`;
    hint.textContent = n === 1 ? '基础套餐 · 4 种戴法'
                     : n === 2 ? '完整套餐 · 15 种戴法'
                     : '3 副完整套餐 · 上百种戴法';
    hint.hidden = false;
    hint.removeAttribute('data-go-build');
    hint.style.cursor = '';
    return;
  }

  // 有副空 → 禁用 + 提示去装(提示自身可点击跳 Tab)
  btn.disabled = true;
  const needBuild = state.builds[incompleteIdx];
  const cnt = [needBuild.faceplate, needBuild.headband, needBuild.earpad].filter(Boolean).length;
  const need = 3 - cnt;
  main.textContent = `先装好第 ${incompleteIdx + 1} 副`;
  hint.textContent = `还差 ${need} 件 · 点这跳过去`;
  hint.hidden = false;
  hint.dataset.goBuild = incompleteIdx;
  hint.style.cursor = 'pointer';
}

// 购前引导:底部固定 library 视觉的 15 套 carousel + 👐 角标(前 2 张是 DIY)
function renderExploreCard(v) {
  if (!v) return '';
  const imgHost = adaptImg('host', v.host, v.form);
  const imgFp   = v.faceplate ? adaptImg('faceplate', v.faceplate, v.form) : 'none';
  const imgEp   = adaptImg('earpad', v.earpad, v.form);
  const imgHb   = adaptImg('headband', v.headband, v.form);
  const epHex   = getColor(v.earpad).hex;
  const hand = v.byBuild === 0 ? '👐 第 1 副' : v.byBuild === 1 ? '👐 第 2 副' : '';
  const formBadge = v.form === 'overear' ? '全包耳' : '半包耳';
  const isCurrent = v.byBuild === state.activeBuild;     // 当前装的那副 → 加白色底"选中态"
  return `
    <div class="explore-card${isCurrent ? ' is-current' : ''}" data-form="${v.form}" data-by-build="${v.byBuild}"
         style="--img-host:${imgHost}; --img-faceplate:${imgFp}; --img-earpad:${imgEp}; --img-headband:${imgHb}; --c-earpad-fb:${epHex};">
      <div class="explore-card__form">${formBadge}</div>
      <div class="preview-card__inner">
        <span class="preview-card__layer preview-card__layer--shadow"></span>
        <span class="preview-card__layer preview-card__layer--earpad"></span>
        <span class="preview-card__layer preview-card__layer--faceplate"></span>
        <span class="preview-card__layer preview-card__layer--host"></span>
        <span class="preview-card__layer preview-card__layer--headband"></span>
      </div>
      ${hand ? `<div class="explore-card__hand">${hand}</div>` : ''}
    </div>
  `;
}
// 合成某副的实时变体(没装齐时降级半包耳 fallback,保证 byBuild=0/1 卡片始终存在)
function buildSlotVariant(buildIdx) {
  const build = state.builds[buildIdx];
  const host = state.base.host;
  const halfEarpad = LOCKED_PAIRS[host];
  const lockedHb = `solid-${halfEarpad}`;
  const hasFull = build.faceplate && build.earpad;
  const v = hasFull ? {
    form: 'overear', host,
    faceplate: build.faceplate, earpad: build.earpad,
    headband: build.headband || lockedHb,
  } : {
    form: 'halfear', host,
    faceplate: null, earpad: halfEarpad,
    headband: build.headband || lockedHb,
  };
  v.byBuild = buildIdx;
  return v;
}
function renderExplore() {
  const carousel = $('#explore-carousel');
  if (!carousel) return;
  const cards = [];
  // slot1 永远显示(Build 1 进站已默认装好)
  cards.push(buildSlotVariant(0));
  // slot2 只在 Build 2 真装齐时出现 — 没 DIY 完不放"标配版"半包耳 fallback
  if (buildComplete(state.builds[1])) {
    cards.push(buildSlotVariant(1));
  }
  // 后接串色搭配(byBuild < 0)
  const others = enumerate().filter(v => v.byBuild < 0);
  cards.push(...others);
  carousel.innerHTML = cards.map(v => renderExploreCard(v)).join('');
  // 居中跟随 activeBuild,找不到对应 byBuild 卡则回到第 1 张
  requestAnimationFrame(() => {
    const target = carousel.querySelector(`.explore-card[data-by-build="${state.activeBuild}"]`);
    if (target) {
      const cardCenter = target.offsetLeft + target.offsetWidth / 2;
      carousel.scrollLeft = cardCenter - carousel.clientWidth / 2;
    } else {
      carousel.scrollLeft = 0;
    }
  });
  // 第 1/2 张可点选 → 切对应 Build 的 activeBuild,Tab 自动跟随
  carousel.querySelectorAll('.explore-card[data-by-build="0"], .explore-card[data-by-build="1"]').forEach(card => {
    card.addEventListener('click', () => {
      const idx = +card.dataset.byBuild;
      // Build 2 卡在 Build 1 未装齐时禁点(避免越级)
      if (idx === 1 && !buildComplete(state.builds[0])) return;
      state.activeBuild = idx;
      state.previewMode = 'build';
      render();
      // 滚动到 Tab 区让用户看到切换效果
      document.querySelector('.kit')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function render() {
  renderHero();
  renderVariants();
  renderHostBar();
  renderPreview();
  renderKit();
  renderExplore();
  renderCta();
}

/* ============================================================
   §13 ANIM · 数字 count-up
   ============================================================ */
function animateCount(el, to) {
  const from = parseInt(el.textContent, 10) || 0;
  if (from === to) return;
  const dur = 380;
  const start = performance.now();
  function tick(now) {
    const t = Math.min(1, (now - start) / dur);
    const eased = 1 - Math.pow(1 - t, 3);
    el.textContent = Math.round(from + (to - from) * eased);
    if (t < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

/* ============================================================
   §14 INIT
   ============================================================ */
// 判断变体是否所有图层 PNG 完整(2026-05-20:半包耳 8 张到位后放开)
function isFullVariant(v) {
  if (!ADAPT_IMAGES.headband.has(v.headband)) return false;
  if (v.form === 'overear') {
    // 全包耳 4 层:头带 + 面盖 + 主机 + 全包皮套
    if (!ADAPT_IMAGES.host.has(v.host)) return false;
    if (v.faceplate && !ADAPT_IMAGES.faceplate.has(v.faceplate)) return false;
    if (!ADAPT_IMAGES.earpad.has(v.earpad)) return false;
    return true;
  }
  if (v.form === 'halfear') {
    // 半包耳 3 层:头带 + 半包主机 + 半包皮套(无面盖)
    if (!ADAPT_IMAGES.host_halfear.has(v.host)) return false;
    if (!ADAPT_IMAGES.earpad_halfear.has(v.earpad)) return false;
    return true;
  }
  return false;
}
// 找到第一个 4 层全有 PNG 的全包耳变体(进站默认显示完整耳机)
function firstFullVariantIdx(variants) {
  for (let i = 0; i < variants.length; i++) {
    if (isFullVariant(variants[i])) return i;
  }
  return 0;
}

// 用户在 DIY 区点了某模块的某色 → 主图自动切到"包含该色的第一个 4 层全 PNG 变体"
function selectVariantBy(field, slug) {
  const variants = enumerate();
  // 优先:overear 形态 + 4 层全 PNG + 该 field == slug
  for (let i = 0; i < variants.length; i++) {
    const v = variants[i];
    if (v[field] !== slug) continue;
    if (v.form !== 'overear') continue;
    if (!ADAPT_IMAGES.host.has(v.host)) continue;
    if (v.faceplate && !ADAPT_IMAGES.faceplate.has(v.faceplate)) continue;
    if (!ADAPT_IMAGES.earpad.has(v.earpad)) continue;
    if (!ADAPT_IMAGES.headband.has(v.headband)) continue;
    state.currentVariantIdx = i;
    return true;
  }
  // 退化:任意包含该色的变体
  for (let i = 0; i < variants.length; i++) {
    if (variants[i][field] === slug) {
      state.currentVariantIdx = i;
      return true;
    }
  }
  return false;
}

function init() {
  // 默认选第一个 4 层全 PNG 的变体(进站第一眼是完整耳机,不是半包 fallback)
  const initialVariants = enumerate();
  state.currentVariantIdx = firstFullVariantIdx(initialVariants);

  // 变体宫格:手指横滑 + 下方进度条实时跟随
  const variantsGrid = $('#variants-grid');
  variantsGrid.addEventListener('scroll', updateVariantsTrack, { passive: true });
  window.addEventListener('resize', updateVariantsTrack);

  // ── 嫁接-21.11 · variants__track slider 可交互:点击瞬移 + 拖动滚(复用 picker-track 模式) ──
  const variantsTrackBar = $('#variants-track-bar');
  const variantsTrackContainer = variantsTrackBar?.parentElement;  // .variants__track
  if (variantsGrid && variantsTrackContainer) {
    const vSeekFromX = (clientX) => {
      const rect = variantsTrackContainer.getBoundingClientRect();
      if (rect.width <= 0) return;
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const sw = variantsGrid.scrollWidth - variantsGrid.clientWidth;
      if (sw > 0) {
        variantsGrid.scrollLeft = sw * ratio;
        updateVariantsTrack();   // 立即同步 thumb
      }
    };
    let vDrag = false, vPid = null, vRaf = null, vPendingX = 0;
    const vFlush = () => { vRaf = null; vSeekFromX(vPendingX); };
    const vSchedule = (x) => { vPendingX = x; if (vRaf == null) vRaf = requestAnimationFrame(vFlush); };
    variantsTrackContainer.addEventListener('pointerdown', (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();
      vDrag = true; vPid = e.pointerId;
      variantsTrackContainer.classList.add('is-dragging');
      try { variantsTrackContainer.setPointerCapture(vPid); } catch (_) {}
      vSeekFromX(e.clientX);
    });
    variantsTrackContainer.addEventListener('pointermove', (e) => {
      if (!vDrag) return;
      e.preventDefault();
      vSchedule(e.clientX);
    });
    const vUp = () => {
      if (!vDrag) return;
      vDrag = false;
      variantsTrackContainer.classList.remove('is-dragging');
      if (vRaf != null) { cancelAnimationFrame(vRaf); vRaf = null; }
      try { variantsTrackContainer.releasePointerCapture(vPid); } catch (_) {}
      vPid = null;
    };
    variantsTrackContainer.addEventListener('pointerup', vUp);
    variantsTrackContainer.addEventListener('pointercancel', vUp);
  }

  // 主图 Carousel(library 模式):手指左右翻 → 同步 currentVariantIdx + preview-name
  const previewCarousel = $('#preview-carousel');
  let scrollDebounce = null;
  previewCarousel.addEventListener('scroll', () => {
    if (state.previewMode !== 'library') return;
    clearTimeout(scrollDebounce);
    scrollDebounce = setTimeout(() => {
      const cards = [...previewCarousel.querySelectorAll('.preview-card')];
      const cRect = previewCarousel.getBoundingClientRect();
      const cCenter = cRect.left + cRect.width / 2;
      // 找最接近视口中央的 card
      let nearest = null, nearestDist = Infinity;
      cards.forEach(card => {
        const r = card.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - cCenter);
        if (dist < nearestDist) { nearestDist = dist; nearest = card; }
      });
      if (!nearest) return;
      const newIdx = parseInt(nearest.dataset.variantIdx, 10);
      if (!isNaN(newIdx) && newIdx !== state.currentVariantIdx) {
        state.currentVariantIdx = newIdx;
        // 轻量更新 preview-name + caption,不全 render(避免 carousel 重渲染破坏滑动)
        const v = enumerate()[newIdx];
        if (v) {
          $('#preview-name').innerHTML = previewNameHTML(v);
          $('#preview-caption').textContent = `搭配库 · 第 ${newIdx + 1} / ${enumerate().length} 套`;
          fillMeta(v);  // 同步竖向白卡 4 行清单
          // 同步搭配库 chip aria-pressed
          document.querySelectorAll('#variants-grid .variant').forEach(el => {
            el.setAttribute('aria-pressed', +el.dataset.idx === newIdx);
          });
        }
      }
    }, 60);
  }, { passive: true });

  // hero ⊕ 教学卡 toggle:hero 区不重绘,绑一次足够
  $('[data-toggle-hero-guide]').addEventListener('click', (e) => {
    e.stopPropagation();
    state.heroGuideOpen = !state.heroGuideOpen;
    renderHero();
  });

  // v16.1 MVP · 加入购物车 = 直跳 Shopify(Shift+点击 = 弹 JSON modal review)
  $('#add-to-cart').addEventListener('click', (e) => {
    if ($('#add-to-cart').disabled) return;
    mvpAddToCart(e);
  });
  // 嫁接-21.13 · 防呆 A · CTA hint 自身可点:禁用状态下点提示跳到未完成那副 Tab + 滚到 picker
  $('#cta-hint')?.addEventListener('click', (e) => {
    const hint = $('#cta-hint');
    const goBuild = hint?.dataset.goBuild;
    if (goBuild === undefined || goBuild === '') return;
    e.preventDefault();
    e.stopPropagation();
    const tab = document.querySelector(`[data-build-tab="${goBuild}"]`);
    if (tab && !tab.classList.contains('is-locked')) tab.click();
    // 滚到对应 picker 让用户视野跟上
    setTimeout(() => {
      const panel = document.querySelector(`.build-tabs__panel[data-build="${goBuild}"]`);
      panel?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 80);
  });
  // 副数选择器(1/2/3 副)click + 同步 state.kitCount + 刷价格
  document.querySelectorAll('#kit-count .kit-count__chip').forEach(chip => {
    chip.addEventListener('click', () => {
      if (chip.disabled) return;
      const n = parseInt(chip.dataset.count, 10);
      state.kitCount = n;
      document.querySelectorAll('#kit-count .kit-count__chip').forEach(c => {
        c.classList.toggle('is-active', parseInt(c.dataset.count, 10) === n);
      });
      $('#total-price').textContent = '$' + totalPriceMvp();
      renderCta();   // 嫁接-8 · 切副数时按钮文案也跟着更新
    });
  });
  // 嫁接-11 · 头带左右箭头翻页(scroll 4 chip 一组)
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-headband-arrow]');
    if (!arrow) return;
    const direction = arrow.dataset.headbandArrow;
    const row = arrow.closest('.picker-strip')?.querySelector('[data-headband-scroll]');
    if (!row) return;
    const chip = row.querySelector('.picker-chip');
    if (!chip) return;
    const step = (chip.offsetWidth + 10) * 4;   // 一次翻 4 chip + 3 gap
    row.scrollBy({ left: direction === 'next' ? step : -step, behavior: 'smooth' });
  });

  // 修复-13 · explore-carousel 左右翻页箭头(桌面端鼠标拖不动 carousel,加箭头)
  const exCarousel = $('#explore-carousel');
  $('#explore-arrow-prev')?.addEventListener('click', () => {
    if (!exCarousel) return;
    const card = exCarousel.querySelector('.explore-card');
    const step = card ? card.offsetWidth + 16 : 240;
    exCarousel.scrollBy({ left: -step, behavior: 'smooth' });
  });
  $('#explore-arrow-next')?.addEventListener('click', () => {
    if (!exCarousel) return;
    const card = exCarousel.querySelector('.explore-card');
    const step = card ? card.offsetWidth + 16 : 240;
    exCarousel.scrollBy({ left: step, behavior: 'smooth' });
  });

  // 修复-13 · 一键批量下载 explore 区所有戴法 PNG(JSZip 打包)
  $('#explore-download')?.addEventListener('click', downloadAllVariantsZip);

  // 嫁接-21 · "你的耳机搭配库"左右翻页箭头(桌面端 click 翻一屏)
  const vGrid = $('#variants-grid');
  $('#variants-arrow-prev')?.addEventListener('click', () => {
    if (!vGrid) return;
    vGrid.scrollBy({ left: -vGrid.clientWidth, behavior: 'smooth' });
  });
  $('#variants-arrow-next')?.addEventListener('click', () => {
    if (!vGrid) return;
    vGrid.scrollBy({ left: vGrid.clientWidth, behavior: 'smooth' });
  });

  render();
  // v15.6 · render 内部 chip scrollIntoView 会副作用滚 .app-shell,初始强制回顶
  requestAnimationFrame(() => {
    const shell = document.querySelector('.app-shell');
    if (shell) shell.scrollTop = 0;
  });
}
init();

/* ============================================================
   §15 MVP · Shopify 嫁接(v16.1 直跳购物车,2026-05-30)
   ============================================================ */
// Shopify 店铺前台域名(用户自定义域 — 比 zvg3ra-pi.myshopify.com 更直接)
const SHOPIFY_DOMAIN = 'monixibi.com';
// 1. 全局映射缓存(启动时 fetch ./data/rainbow-mapping.json)
let SHOPIFY_MAPPING = null;

// 2. slug → Shopify variant 翻译(从 mapping.json 查)
function mvpMapSlug(category, slug) {
  if (!SHOPIFY_MAPPING || !slug) return null;
  const entry = SHOPIFY_MAPPING[category]?.[slug];
  if (!entry) return null;
  return {
    variant_id: entry.variant_id,
    sku: entry.sku || '(空)',
    title: entry.variant_title,
    price: entry.price,
    product_handle: entry.product_handle,
  };
}

// 3. 生成完整 Shopify Ajax Cart payload(数据包)
// 阶段 C · 加购协议彻底重写(2026-06-01)
// 旧:6 件散加(主机 + 头带/面盖/皮套 × 每副)→ 6 行 line item,触发零件 5 折逻辑(错的)
// 新:1 个 DIY product variant + line item properties 携带配色 → 1 行 line item,自动享套装折扣
// SoT 见 Shopify 后台工作区 plan 文档「Rainbow 价格体系 + DIY 模块对接交付包 2026-06-01」§ 二、三、四
function mvpBuildPayload() {
  const host = state.base.host;
  const kitCount = state.kitCount;
  const variantId = DIY_VARIANT_IDS[kitCount] || DIY_VARIANT_IDS[2];

  // 颜色名 → 英文(properties 规范,Shopify 后台统一)
  const hostEn = HOST_EN[host] || host;
  const moniSlug = getMoniStrapSlug();
  const moniEn = MONI_STRAP_EN[moniSlug] || moniSlug;
  const moniCn = MONI_STRAPS.find(m => m.slug === moniSlug)?.cn || moniSlug;

  // properties 命名规范:
  //   1 副:Host Color / Faceplate Color / Over-Ear Cushion / Headband Design / Moni-Strap Color(无 Set 后缀)
  //   2/3 副:Faceplate/Cushion/Headband 加 (Set N) 后缀,Host/Moni-Strap 全局唯一
  // 头带英文名 SoT 还没整理,暂用中文 cn(后续做 44 款英文映射后切换)
  const properties = {
    'Host Color': hostEn,
    // 阶段 E · cart 端缩略图渲染要用的 host slug(全局唯一,不分副)
    _host_slug: host,
  };

  // 每副的 3 件零件(按 kitCount 取前 N 副)
  const useSetSuffix = kitCount > 1;
  state.builds.slice(0, kitCount).forEach((b, i) => {
    const setN = i + 1;
    const suffix = useSetSuffix ? ` (Set ${setN})` : '';
    const fpEn   = FACEPLATE_EN[b.faceplate] || b.faceplate || '?';
    const epEn   = EARPAD_EN[b.earpad] || b.earpad || '?';
    // 头带:取 cn 中文(英文 SoT 待整理)
    const hbCn   = getColor(b.headband)?.cn || b.headband || '?';
    properties[`Faceplate Color${suffix}`]  = fpEn;
    properties[`Over-Ear Cushion${suffix}`] = epEn;
    properties[`Headband Design${suffix}`]  = hbCn;
    // 阶段 E · 给 cart 端缩略图渲染脚本反查 slug 用(下划线 = 隐藏给客户)
    properties[`_faceplate_slug${suffix}`] = b.faceplate || '';
    properties[`_earpad_slug${suffix}`]    = b.earpad    || '';
    properties[`_headband_slug${suffix}`]  = b.headband  || '';
  });

  // 魔尼带(全套装 1 件,所有副数都加这一行,不带 Set 后缀)
  properties['Moni-Strap Color'] = moniEn;
  properties._moni_slug = moniSlug;

  // 店主拣货用 _ 下划线 metadata(客户不可见)
  properties._ui_version = 'v17.1-stage-e-2026-06-02';
  properties._kit_count = kitCount;
  properties._diy_variant_id = variantId;
  properties._魔尼带色名_中文 = moniCn;
  properties._魔尼带_锁色态 = state.moniStrap.linked ? 'locked' : 'free';

  return {
    meta: {
      ui_version: 'v17.0-stage-c',
      timestamp: new Date().toISOString(),
      kit_count: kitCount,
      total_price_usd: totalPriceMvp(),
      diy_variant_id: variantId,
      note: '阶段 C · 1 个 DIY product variant + properties(取代旧 6 件散加)。Shopify 自动套装折扣 20% / BxGy / ≥3 件 30%。',
    },
    shopify_ajax_cart_payload: {
      id: variantId,           // 数字 ID(直接用)
      quantity: 1,
      properties: properties,
    },
  };
}

// 4. 点击 Add to Cart 时触发
//    Shift+点击 = 弹 JSON modal(开发 review,平时不用)
//
// 阶段 C v3(2026-06-16 凌晨修复 02:13 慢 + Load failed 双痛点):
//   ── 双路径策略 ──
//   ① 快路径:fetch /cart/add.js(batch add 1 个 bundle variant + properties)→ 同源跳 /cart
//      Shopify 处理 1 个 variant ≈ 0.5-1 秒,体验快
//   ② 慢路径(自动降级):fetch 失败(Safari 隐私模式 / Webview / 网络) → cart permalink 跳转
//      推 N 个 variant(4-10 件),Shopify 逐个处理,4-15 秒
//   ── 体感优化 ──
//   ③ 立即弹"正在装入购物车"进度 modal,缓解等待焦虑(无论快慢路径都有反馈)
//   ── 历史 ──
//   v2(2026-06-16 早晨):全部走 cart permalink 慢路径,因 v1 fetch 在 Safari 隐私模式抛 Load failed
//   v1(2026-06-02):全部走 fetch,Safari 隐私模式 / Webview 下偶尔失败
async function mvpAddToCart(e) {
  const payload = mvpBuildPayload();
  console.log('[Stage C v3 AddToCart] payload =', payload);

  // Shift + click → 弹 JSON modal(开发 review,平时不弹)
  if (e && e.shiftKey) { mvpShowModal(payload); return; }

  // ① 立即显示进度 modal — 用户立刻看到反馈,不焦虑
  const progressModal = showAddingProgressModal();

  try {
    // ② 快路径:fetch /cart/add.js(1 个 bundle variant + properties)
    const items = mvpCollectCartItems(payload);
    if (!items.length || !items[0].id) {
      throw new Error('DIY variant_id 缺失');
    }
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!resp.ok) {
      const errBody = await resp.text().catch(() => '');
      throw new Error(`HTTP ${resp.status}: ${errBody.slice(0, 200)}`);
    }
    // ③ 成功 → 同源跳 /cart 页(比新标签页快,modal 跟着卸载)
    console.log('[Stage C v3 快路径] fetch 成功,跳 /cart');
    window.location.href = '/cart';
    return;
  } catch (err) {
    // ④ 慢路径降级:fetch 挂了(Safari 隐私 / Webview / 网络) → cart permalink 兜底
    console.warn('[Stage C v3] 快路径失败,降级 cart permalink:', err);
    const url = mvpBuildCartUrl(payload);
    if (!url) {
      closeAddingProgressModal(progressModal);
      alert('⚠️ 主机 variant_id 缺失,无法跳购物车。\n\nShift+点击 看 JSON 数据排查。');
      return;
    }
    console.log('[Stage C v3 慢路径降级] cart permalink:', url);
    // 同源跳转(慢但稳),modal 随页面卸载自动消失
    window.location.href = url;
  }
}

// 阶段 C v3 辅助:加购进度 modal(2026-06-16)
// 立即弹出 + spinner + 文字,缓解 Shopify 处理 5-15 秒的等待焦虑
function showAddingProgressModal() {
  // 如果已存在(防连点),直接返回旧的
  const existing = document.getElementById('rainbow-adding-modal');
  if (existing) return existing;

  const modal = document.createElement('div');
  modal.id = 'rainbow-adding-modal';
  modal.style.cssText = `
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 2147483647;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: rainbow-fade-in 0.2s ease;
    -webkit-tap-highlight-color: transparent;
  `;
  modal.innerHTML = `
    <style>
      @keyframes rainbow-fade-in {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      @keyframes rainbow-spin {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    </style>
    <div style="
      background: white;
      border-radius: 18px;
      padding: 28px 36px;
      text-align: center;
      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.28);
      min-width: 200px;
      max-width: 280px;
    ">
      <div style="
        width: 44px;
        height: 44px;
        margin: 0 auto 18px;
        border: 3.5px solid #f0f0f0;
        border-top-color: #1d1d1f;
        border-radius: 50%;
        animation: rainbow-spin 0.7s linear infinite;
      "></div>
      <div style="
        font-size: 15px;
        font-weight: 700;
        color: #1d1d1f;
        margin-bottom: 6px;
        letter-spacing: .01em;
      ">正在装入购物车</div>
      <div style="
        font-size: 12px;
        color: #888;
        line-height: 1.5;
      ">马上就好,请稍候</div>
    </div>
  `;
  document.body.appendChild(modal);
  return modal;
}

function closeAddingProgressModal(modal) {
  const target = modal || document.getElementById('rainbow-adding-modal');
  if (target && target.parentNode) {
    target.style.transition = 'opacity 0.2s';
    target.style.opacity = '0';
    setTimeout(() => target.remove(), 200);
  }
}

// 收集所有 cart line items(主机 1 件 + 每副的头带/面盖/全包皮套 各 1)
// 阶段 C · 加购 items 现在只有 1 行(DIY product variant + properties)
function mvpCollectCartItems(payload) {
  const item = payload.shopify_ajax_cart_payload;
  if (!item || !item.id) return [];
  return [{
    id: item.id,
    quantity: item.quantity || 1,
    properties: item.properties || {},
  }];
}

// 4b. 生成 Shopify 多变体购物车直链(cart permalink)
// 格式:https://store/cart/{vid1}:{qty1},{vid2}:{qty2},...?attributes[Key]=Value&...
// 多变体每个会显示成购物车 1 个 line item:
//   1 副 = 4 件(主机 + 头带 + 面盖 + 全包皮套)
//   2 副 = 7 件(主机 + 6 零件)
function mvpBuildCartUrl(payload) {
  const item = payload.shopify_ajax_cart_payload;
  if (!item || !item.id) return null;

  // 2026-06-16 修复:item.id 可能是 number(DIY_VARIANT_IDS L77 numeric)
  // 也可能是 string "gid://shopify/ProductVariant/123" 或 "123"
  // 统一抽数字 ID:String + split('/').pop() + 校验全数字
  // 原代码 typeof !== 'string' 强类型检查导致 number 直接 return null →
  // 第一次 fetch 失败时降级到 cart permalink 弹"variant_id 缺失"alert(用户报 11:44 截图)
  const variantIdNum = String(item.id).split('/').pop();
  if (!variantIdNum || !/^\d+$/.test(variantIdNum)) return null;

  const items = [`${variantIdNum}:1`];
  // 兼容老 builds_detail_for_picking 平铺方案(当前 v3 是 1 件 bundle,不会进此分支)
  (payload.builds_detail_for_picking || []).forEach(b => {
    [b.headband_shopify, b.faceplate_shopify, b.earpad_shopify].forEach(s => {
      if (s && s.variant_id) {
        const vid = String(s.variant_id).split('/').pop();
        if (vid && /^\d+$/.test(vid)) items.push(`${vid}:1`);
      }
    });
  });

  const parts = Object.entries(item.properties || {}).map(([k, v]) => {
    return `attributes[${encodeURIComponent(k)}]=${encodeURIComponent(String(v))}`;
  });
  const qs = parts.length ? '?' + parts.join('&') : '';

  return `https://${SHOPIFY_DOMAIN}/cart/${items.join(',')}${qs}`;
}

// 5. modal 弹窗(显示 JSON 给店主 review)
function mvpShowModal(payload) {
  let modal = document.getElementById('mvp-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'mvp-modal';
    modal.className = 'mvp-modal';
    modal.innerHTML = `
      <div class="mvp-modal__backdrop" data-close="1"></div>
      <div class="mvp-modal__panel">
        <div class="mvp-modal__head">
          <div class="mvp-modal__title">📦 加入购物车 · 数据包预览(MVP)</div>
          <button class="mvp-modal__close" data-close="1" type="button" aria-label="关闭">✕</button>
        </div>
        <div class="mvp-modal__hint">
          <b>MVP 跳验模式</b>:不会真发到 Shopify,只显示这份 JSON(数据包)给你 review。<br>
          ✅ 检查重点:① <code>shopify_ajax_cart_payload.id</code> 是不是主机 variant_id;② 每副的 <code>_build*_variant_ids</code> 是不是 3 个 ID 用逗号连接;③ <code>主机色</code> 跟你在 UI 选的一致。
        </div>
        <pre class="mvp-modal__pre" id="mvp-modal-pre"></pre>
        <div class="mvp-modal__foot">
          <button class="mvp-modal__btn" data-close="1" type="button">关闭</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => {
      if (e.target.dataset && e.target.dataset.close === '1') {
        modal.classList.remove('is-open');
      }
    });
  }
  document.getElementById('mvp-modal-pre').textContent = JSON.stringify(payload, null, 2);
  modal.classList.add('is-open');
}

// 6. CSS 注入(副数选择器 + modal,避免动现有 <style> 区)
function mvpInjectStyles() {
  if (document.getElementById('mvp-styles')) return;
  const style = document.createElement('style');
  style.id = 'mvp-styles';
  style.textContent = `
    /* 嫁接-14 · 副数选择器:单行扁平,价格剥离去右侧 .cta-bar__price 显示 */
    .kit-count { display: flex; gap: 6px; margin: 0; width: 100%; }
    .kit-count__chip {
      flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px;
      min-height: 32px; padding: 4px 8px;
      border: 1px solid rgba(20,20,20,.14); border-radius: 8px;
      background: #fff; cursor: pointer; position: relative; font-family: inherit;
      transition: background .15s ease, border-color .15s ease, color .15s ease;
    }
    .kit-count__chip:hover:not(:disabled):not(.is-active) { border-color: rgba(20,20,20,.3); }
    .kit-count__chip.is-active {
      background: #1d1d1f; color: #fff; border-color: #1d1d1f;
    }
    .kit-count__chip.is-disabled { opacity: .45; cursor: not-allowed; }
    .kit-count__num { font-size: 13px; font-weight: 600; letter-spacing: .2px; line-height: 1; }
    /* chip 内的小价格隐藏(总价已移到右侧大字显示) */
    .kit-count__price { display: none; }
    .kit-count__tag {
      position: absolute; top: -6px; right: -3px;
      background: #E0432F; color: #fff;
      font-size: 9px; padding: 1px 4px; border-radius: 4px;
      font-weight: 600; letter-spacing: .2px; line-height: 1.2;
    }
    .kit-count__tag--soon { background: #999; }

    /* MVP modal · JSON 预览 */
    .mvp-modal { position: fixed; inset: 0; display: none; z-index: 9999; font-family: inherit; }
    .mvp-modal.is-open { display: block; }
    .mvp-modal__backdrop {
      position: absolute; inset: 0;
      background: rgba(0,0,0,.55); backdrop-filter: blur(4px);
    }
    .mvp-modal__panel {
      position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
      width: min(92vw, 720px); max-height: 86vh;
      background: #fff; border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0,0,0,.3);
      display: flex; flex-direction: column; overflow: hidden;
    }
    .mvp-modal__head {
      display: flex; align-items: center; justify-content: space-between;
      padding: 14px 18px; border-bottom: 1px solid rgba(20,20,20,.08);
    }
    .mvp-modal__title { font-size: 15px; font-weight: 600; }
    .mvp-modal__close {
      width: 28px; height: 28px; border-radius: 50%;
      background: rgba(20,20,20,.06); border: none; cursor: pointer;
      font-size: 14px; color: inherit; font-family: inherit;
    }
    .mvp-modal__close:hover { background: rgba(20,20,20,.12); }
    .mvp-modal__hint {
      padding: 12px 18px; font-size: 12px; line-height: 1.55;
      color: #444; background: #FAF7EE;
    }
    .mvp-modal__hint code {
      background: #fff; padding: 1px 5px; border-radius: 3px;
      font-family: 'SF Mono', Menlo, monospace; font-size: 11px;
    }
    .mvp-modal__pre {
      flex: 1; margin: 0; padding: 14px 18px;
      background: #1d1d1f; color: #C5C9D2;
      font-family: 'SF Mono', Menlo, Consolas, monospace;
      font-size: 11px; line-height: 1.55;
      overflow: auto; white-space: pre-wrap; word-break: break-word;
    }
    .mvp-modal__foot {
      padding: 12px 18px; border-top: 1px solid rgba(20,20,20,.08);
      display: flex; justify-content: flex-end;
    }
    .mvp-modal__btn {
      background: #1d1d1f; color: #fff; border: none; cursor: pointer;
      padding: 8px 18px; border-radius: 8px; font-size: 13px;
      font-family: inherit;
    }
    .mvp-modal__btn:hover { background: #000; }
  `;
  document.head.appendChild(style);
}

// 7. MVP 自启动(注入 CSS + 加载映射)
(function mvpBootstrap() {
  mvpInjectStyles();
  (function() {
    SHOPIFY_MAPPING = SHOPIFY_MAPPING_INLINE;
    const counts = ['host','faceplate','earpad_full','earpad_half','headband','moni_strap']
      .map(k => `${k}=${Object.keys(SHOPIFY_MAPPING[k]||{}).length}`).join(' / ');
    console.log('[MVP] Shopify 映射已加载(inline) (' + counts + ')');
  })();
})();